export const translations = {
  en: {
    nav: { home: "Home", about: "About Us", services: "Services", why: "Why Choose Us", contact: "Contact", whatsapp: "WhatsApp Us" },
    hero: {
      badge: "Hospitality Technology, Make for India",
      line1: "India's First & Fastest Growing",
      line2: "AI-native Hospitality Technology",
      line3: "Infrastructure Brand",
      sub: "Every Accommodation's Booking & Revenue Growth Partner",
      paragraph: "",
      chips: ["No overbookings", "More Online Bookings", "Online Booking Support"],
      ctaPrimary: "Get Started on WhatsApp",
      ctaSecondary: "Explore Services",
    },
    stats: {
      accommodations: "Accommodations",
      cities: "Cities",
      states: "States",
      otas: "OTAs managed in one place",
      support: "Online Booking Support",
    },
    servicesOverview: {
      eyebrow: "Everything your hotel runs on",
      title: "Ten services. One partner.",
      subtitle:
        "Empty rooms, messy OTA listings, missed enquiries and overbookings cost you every single night. Superhost Cloud fixes all of it — so you get more direct bookings, better visibility and a front desk that runs itself.",
      learnMore: "Learn more",
      viewAll: "View all services",
    },
    services: {
      "ota-management": {
        title: "OTA Listing & Management",
        short:
          "Apne hotel ko major OTA platforms par list karein aur apni online presence ko professionally manage karein.",
      },
      "channel-management": {
        title: "Channel Management",
        short:
          "One dashboard to sync rates and availability across every OTA in real time. No more overbookings.",
      },
      "room-pricing": {
        title: "Room Partition & Pricing",
        short:
          "Smart room categorisation and dynamic pricing that captures demand and maximises every night's revenue.",
      },
      "hotel-crm": {
        title: "Hotel CRM",
        short:
          "Manage guest information, enquiries and booking history in one place. Build stronger guest relationships and create more opportunities for repeat bookings.",
      },
      "whatsapp-automation": {
        title: "WhatsApp Automation",
        short:
          "Automate guest conversations, booking confirmations, vouchers and reminders — giving your guests faster responses while reducing repetitive work for your hotel team.",
      },
      "front-office": {
        title: "Front Office System",
        short:
          "Manage check-ins, check-outs, guest details, room status and housekeeping from one simple front-desk system.",
      },
      "revenue-management": {
        title: "Booking & Revenue Management",
        short:
          "Track bookings, revenue and room performance in one place. Use real-time data and smarter revenue strategies to make better pricing decisions.",
      },
      "website-development": {
        title: "Hotel Website Development",
        short:
          "A modern, mobile-friendly hotel website with room showcases, direct booking functionality and a seamless guest experience.",
      },
      "social-media": {
        title: "Social Media Marketing",
        short:
          "Professional content, reels and social media campaigns designed to increase your hotel's visibility, engagement and online presence.",
      },
      "owner-support": {
        title: "Hotel Online Booking Support",
        short:
          "Dedicated support for your hotel's online bookings, OTA channels, rates, inventory and technology-related queries.",
      },
    },
    clientStrip: { trusted: "Trusted by hotels & resorts across India" },
    whyChoose: {
      eyebrow: "Why Choose Us",
      title: "Why hotel owners choose Superhost Cloud",
      subtitle:
        "We're not just another software vendor. We're the partner that treats your rooms like our own — combining technology, distribution and real human support under one roof.",
      reasons: [
        { h: "One partner for everything", p: "OTA listings, channel management, revenue, CRM, website and marketing — ten services working together, not ten vendors to chase." },
        { h: "Real human support", p: "A dedicated team that actually picks up the phone and understands how Indian hotels run — no ticket queues, no bots." },
        { h: "Built for Indian hospitality", p: "From 8-room boutique stays to large resorts, everything is tailored to Indian owners, guests and booking behaviour." },
        { h: "Results you can measure", p: "More direct bookings, fewer overbookings and better visibility — most owners see a clear lift within 4–8 weeks." },
      ],
    },
    testimonialsSection: {
      eyebrow: "Real owners. Real results.",
      title: "Hotel owners who bet on Superhost Cloud",
    },
    testimonials: [
      {
        name: "Hotel Nilay",
        quote:
          "Before Superhost Cloud, we had low online visibility and handling bookings was messy. Superhost Cloud made everything easier — listing our hotel on the OTAs, managing our rates, and confirming bookings. Now we get regular bookings and our online presence has clearly improved. It's been a real boost for our business!",
      },
      {
        name: "The Imperial Hotel And Restaurant",
        quote:
          "Superhost Cloud didn't just help us with bookings — they made sure we're visible on all major OTAs with the right rates and real-time updates. Guests are booking smoothly, and the overall experience has improved a lot. It's truly been a game-changer for us!",
      },
      {
        name: "Vrrinda Home Stay",
        quote:
          "Earlier, we spent hours dealing with OTA issues. Since switching to Superhost Cloud, their team takes care of our OTA listings, rate management and bookings in the background. Now we focus on our guests, not escalations — total peace of mind!",
      },
      {
        name: "Hotel Indra Palace",
        quote:
          "Superhost Cloud listed our property across the OTAs with ease, made confirming bookings simple, and managed our rates properly. With their complete support, running the hotel has become much easier!",
      },
      {
        name: "Vaishnavi dham",
        quote:
          "Earlier we didn't understand how to handle online platforms and OTA listings. Superhost Cloud took charge of OTA management, rates and bookings — everything. Now we get confirmed bookings, timely payments and excellent support. It has truly been a big help for us!",
      },
      {
        name: "P VEE Resorts",
        quote:
          "Our online presence has improved and the stress has reduced. Superhost Cloud helped with everything — OTA listing, rate management and booking management. We are completely satisfied and I would strongly recommend Superhost Cloud to all hoteliers!",
      },
      {
        name: "Hotel Bandu",
        quote:
          "Fake bookings were a big problem, but now Superhost Cloud filters them out and brings only confirmed, paying guests. On top of that, our OTA listings and rates are now managed from one place. We now get reliable reservations, timely updates and happy guests. It's been a big change for us.",
      },
      {
        name: "Hotel Nilamber",
        quote:
          "Superhost Cloud is like a reliable partner for us. They handle OTA listing, reservations, rate management and all guest-related responsibilities, so we can focus completely on serving our guests.",
      },
    ],
    lead: {
      eyebrow: "Free consultation",
      title: "Let's fill your rooms",
      paragraph:
        "Tell us about your property. Our team will audit your online presence and show you exactly where you're losing bookings — completely free, no obligation.",
      bullets: [
        "Free listing & channel audit",
        "A tailored growth plan for your hotel",
        "Response within 24 hours",
      ],
      whatsappPrefer: "Prefer WhatsApp? Chat now",
    },
    form: {
      fullName: "Full Name *",
      hotelName: "Hotel / Property Name",
      mobile: "Mobile Number *",
      email: "Email Address *",
      mobileInvalid: "Please enter a valid 10-digit mobile number.",
      city: "City",
      state: "State",
      other: "Other",
      rooms: "Number of Rooms",
      service: "Service Interested In",
      message: "Message / Requirements",
      ph: {
        name: "Your name",
        property: "Property name",
        mobile: "10-digit number",
        email: "@email.com",
        city: "City",
        rooms: "e.g. 24",
        select: "Select a service",
        selectCity: "Select city",
        selectState: "Select state",
        selectStateFirst: "Select a state first",
        otherCity: "Enter your city",
        otherState: "Enter your state",
        message: "Tell us what you need...",
      },
      serviceOptions: [
        "Hotel Management Software",
        "Channel Manager",
        "Booking Management",
        "Website Development",
        "Revenue Management",
        "Digital Marketing",
        "Other",
      ],
      submit: "Send Enquiry",
      sending: "Sending...",
      thankyouTitle: "Thank you!",
      thankyouMsg: "Our team will contact you shortly.",
      another: "Submit another enquiry",
      reqTitle: "Please complete the required fields",
      reqDesc: "Name, mobile number and email are required.",
      errTitle: "Something went wrong",
      errDesc: "Please try again or reach us on WhatsApp.",
    },
    faqSection: { eyebrow: "FAQ", title: "Answers for hotel owners" },
    faqs: [
      {
        q: "What exactly does Superhost Cloud do?",
        a: "We are a hospitality technology and hotel management company. We handle everything from OTA listings, channel management and revenue strategy to WhatsApp automation, CRM, website development and marketing — so hotel owners get more bookings with less stress.",
      },
      {
        q: "Do I need to be tech-savvy to use your services?",
        a: "Not at all. Our team sets everything up for you and provides ongoing support. You focus on your guests; we handle the technology and distribution.",
      },
      {
        q: "How quickly will I see results?",
        a: "Most hotel owners see a noticeable lift in enquiries and bookings within the first 4–8 weeks, once listings are optimised and channels are properly connected.",
      },
      {
        q: "Do you work with small independent hotels?",
        a: "Yes. From 8-room boutique stays to large properties, our services scale to fit your size and budget.",
      },
      {
        q: "How do I get started?",
        a: "Tap any WhatsApp button or fill out the contact form. Our team will reach out, understand your property and recommend the right plan for you.",
      },
    ],
    cta: {
      homeTitle: "Ready to fill more rooms?",
      homeSubtitle:
        "Talk to our team today. We'll audit your listings and show you exactly where you're losing bookings — free.",
      servicesTitle: "Not sure where to start?",
      servicesSubtitle:
        "Tell us about your property and we'll recommend the right mix of services for your goals and budget.",
      aboutTitle: "Let's grow your hotel together",
      aboutSubtitle:
        "Join hundreds of Indian hotel owners who trust Superhost Cloud to fill their rooms.",
      whatsappBtn: "Chat on WhatsApp",
      freeConsult: "Get a Free Consultation",
    },
    servicesPage: {
      eyebrow: "Our Services",
      title1: "EVERYTHING",
      title2: "YOUR HOTEL NEEDS",
      paragraph:
        "Ten focused services that work together to bring you more bookings, better visibility and a hotel that runs like clockwork.",
      learnMore: "Learn more",
      enquire: "Enquire",
    },
    sdUI: {
      allServices: "All Services",
      talkWhatsapp: "Talk to us on WhatsApp",
      overview: "Overview",
      whatItDoes: "What it does for you",
      benefitsTitle: "Benefits for hotel owners",
      getFreeConsult: "Get a free consultation",
      notFound: "Service not found",
      back: "Back to Services",
      getStarted: "Get Started",
      talkExpert: "Talk to an Expert",
      enquireNow: "Enquire Now",
      waLead: "Hi Superhost Cloud, I'd like to know more about",
      waTail: ".",
    },
    richServiceDetail: {
      "channel-management": {
        subtitle: "Manage All Your Hotel Booking Channels From One Place",
        body:
          "Managing multiple OTA platforms manually can be time-consuming and can lead to rate mismatches, inventory errors and overbooking. Superhost Cloud Channel Management helps hotels manage their connected booking channels from one centralized dashboard, making it easier to control rates, availability, room inventory and bookings.",
        featuresHeading: "One Dashboard. Multiple Booking Channels.",
        featuresIntro:
          "Your hotel may receive bookings from multiple online channels. Instead of managing each platform separately, Superhost Cloud brings your channel management into one place.",
        features: [
          { title: "Rate Synchronization", desc: "Update your room rates efficiently across connected booking channels." },
          { title: "Availability Management", desc: "Manage room availability from one centralized system." },
          { title: "Inventory Management", desc: "Keep your room inventory organized and synchronized across connected channels." },
          { title: "Booking Management", desc: "View and manage bookings received through your connected channels." },
          { title: "Reduce Overbooking Risk", desc: "Keep your inventory updated across connected channels to help reduce the chances of double-selling rooms." },
          { title: "Centralized Rate Control", desc: "Manage your room pricing from one place and maintain better control over your distribution." },
        ],
        stepsHeading: "How Channel Management Works",
        steps: [
          { no: "01", title: "Connect Your Channels", desc: "Connect your supported OTA and booking channels with Superhost Cloud." },
          { no: "02", title: "Manage From One Dashboard", desc: "Control rates, availability and inventory from a centralized dashboard." },
          { no: "03", title: "Synchronize Your Inventory", desc: "Changes to your configured rates and availability are synchronized with connected channels." },
          { no: "04", title: "Manage Your Bookings", desc: "View bookings from connected channels and manage your hotel operations from one system." },
        ],
        whyHeading: "Why Choose Superhost Cloud?",
        whySub: "Stop Managing Multiple Channels Manually",
        whyText:
          "Switching between different OTA dashboards can take valuable time and increase the chances of manual errors. Superhost Cloud gives your hotel a centralized channel management solution designed to simplify your online distribution.",
        bulletsIntro: "With Superhost Cloud, you can:",
        bullets: [
          "Manage multiple channels from one place",
          "Keep room availability organized",
          "Manage rates efficiently",
          "Centralize booking information",
          "Reduce repetitive manual updates",
          "Improve control over your online inventory",
        ],
        builtHeading: "Built for Modern Hotels",
        builtText:
          "Whether you manage a small hotel, boutique property, resort, homestay or multiple properties, centralized channel management can make your daily operations easier. Spend less time managing platforms. Spend more time growing your hotel.",
      },
      "room-pricing": {
        subtitle: "Manage Your Rooms Better",
        body: "Create and manage different room categories from one centralized system.",
        features: [
          { title: "Room Categorisation", desc: "Create separate room types based on room size, occupancy, amenities, view and other features." },
          { title: "Flexible Room Pricing", desc: "Set different rates for different room categories and pricing requirements." },
          { title: "Better Revenue Control", desc: "Understand your room categories and pricing structure to make better revenue decisions." },
          { title: "Occupancy-Based Pricing", desc: "Manage pricing according to guest occupancy and room requirements." },
          { title: "Date-Based Rates", desc: "Set different prices for different dates, seasons or demand periods." },
          { title: "Easy Rate Management", desc: "Update room rates and manage your pricing structure from one place." },
        ],
        stepsHeading: "How It Works",
        steps: [
          { no: "01", title: "Create Room Categories", desc: "Define your room types such as Standard, Deluxe, Premium, Suite, etc." },
          { no: "02", title: "Add Room Details", desc: "Add occupancy, amenities, room count and other relevant details." },
          { no: "03", title: "Set Your Pricing", desc: "Configure rates according to your room category and business requirements." },
          { no: "04", title: "Manage & Update", desc: "Make pricing and room changes whenever your business needs them." },
        ],
        whyHeading: "Why Smart Room Pricing Matters",
        whyText:
          "Different rooms have different values, so keeping the same pricing for every room may not always make sense. With Superhost Cloud, you can structure your room categories and pricing more effectively, helping you maintain better control over your inventory and revenue strategy.",
        whyTagline: "Right Room. Right Price. Better Revenue Opportunities.",
        builtHeading: "Built for Growing Hotels",
        builtText:
          "Whether you manage a hotel, resort, boutique property or homestay, Superhost Cloud helps you organise your room categories and pricing in a simple and centralized system.",
        closingHeading: "Ready to Manage Your Rooms Smarter?",
        closingText: "Create better room categories. Manage pricing efficiently. Build a smarter revenue strategy.",
      },
      "hotel-crm": {
        subtitle: "Build Stronger Guest Relationships & Drive Repeat Bookings",
        body:
          "Superhost Cloud Hotel CRM helps you manage guest information, enquiries, booking history and customer interactions from one centralized platform. Understand your guests better, follow up with enquiries and stay connected with past customers to create more opportunities for repeat bookings.",
        heroButtons: [{ label: "Enquire Now", type: "primary", action: "contact" }],
        featuresHeading: "Manage Your Guest Relationships in One Place",
        features: [
          { title: "Centralized Guest Database", desc: "Store and organize important guest information in one place for easy access and management." },
          { title: "Guest Booking History", desc: "View previous stays and booking information to better understand your returning guests." },
          { title: "Enquiry Management", desc: "Keep track of guest enquiries and follow-ups so potential bookings don't get missed." },
          { title: "Repeat Guest Management", desc: "Identify returning guests and maintain their booking history for a more personalized experience." },
          { title: "Guest Communication", desc: "Keep your guest interactions organized and make follow-ups easier." },
          { title: "Guest Insights", desc: "Use guest and booking information to understand customer patterns and make better business decisions." },
        ],
        stepsHeading: "How Hotel CRM Works",
        steps: [
          { no: "01", title: "Capture Guest Information", desc: "Collect and organize guest details from your enquiries and bookings." },
          { no: "02", title: "Track Every Interaction", desc: "Keep important guest conversations, enquiries and follow-ups organized." },
          { no: "03", title: "Understand Guest History", desc: "Access previous booking and stay information when needed." },
          { no: "04", title: "Build Long-Term Relationships", desc: "Stay connected with your guests and create opportunities for repeat bookings." },
        ],
        whyHeading: "Turn One-Time Guests Into Returning Guests",
        whyText:
          "A guest relationship shouldn't end after checkout. With Superhost Cloud Hotel CRM, you can keep your guest information and booking history organized, making it easier to understand your customers and build long-term relationships.",
        whyTagline: "Know Your Guests. Stay Connected. Grow Repeat Bookings.",
        builtHeading: "Why Hotels Need a CRM",
        builtText:
          "Managing guest information across notebooks, spreadsheets, WhatsApp chats and different systems can make follow-ups difficult. Superhost Cloud brings your guest-related information into one centralized system, helping your team stay organized and manage customer relationships more efficiently.",
        closingHeading: "Ready to Build Better Guest Relationships?",
        closingText: "Manage guest information, enquiries and booking history from one centralized hotel CRM.",
      },
      "whatsapp-automation": {
        subtitle: "Turn Every Guest Conversation Into a Better Booking Experience",
        body:
          "Superhost Cloud WhatsApp Automation helps hotels communicate with guests faster and more efficiently through automated booking confirmations, vouchers, reminders and guest support. From the moment a guest makes an enquiry to the time they complete their stay, your hotel can keep important communication organized and timely — directly on WhatsApp.",
        aiConcierge: {
          eyebrow: "WhatsApp AI Concierge",
          heading: "24/7 AI-Powered Guest Communication",
          intro:
            "Give your guests instant assistance with an AI-powered WhatsApp Concierge designed for modern hotel operations.",
          points: [
            { title: "24/7 Guest Support", desc: "Respond to guest queries anytime, day or night." },
            { title: "17-Second Median Reply", desc: "Deliver fast responses to common guest enquiries." },
            { title: "Hindi & English Support", desc: "Communicate with guests in both Hindi and English." },
            { title: "Automated Guest Communication", desc: "Streamline booking enquiries, confirmations, reminders, and guest assistance through WhatsApp." },
          ],
          footer: "With Superhost Cloud, your hotel stays connected with guests — even when your team is busy.",
        },
        featuresHeading: "Your Hotel's Communication, Automated",
        featuresIntro:
          "Hotels receive the same types of messages every day — booking confirmations, voucher requests, check-in questions, reminders and basic property queries. Instead of handling every message manually, Superhost Cloud helps automate repetitive communication while keeping your guests informed.",
        features: [
          { title: "Instant Guest Responses", desc: "Respond to common guest questions quickly and keep your guests from waiting for a response from the front desk." },
          { title: "Automated Booking Confirmation", desc: "Once a booking is confirmed, automatically send the relevant booking information to the guest on WhatsApp." },
          { title: "Booking Voucher on WhatsApp", desc: "Send the guest their booking voucher and reservation details directly through WhatsApp." },
          { title: "Automated Reminders", desc: "Send timely reminders and important information before the guest's stay." },
          { title: "Pre-Arrival Communication", desc: "Share useful information such as check-in details, property information and other configured instructions before arrival." },
          { title: "Human Handover", desc: "When a conversation requires personal assistance, the hotel team can take over and continue the conversation with the guest." },
        ],
        stepsHeading: "From Enquiry to Guest Communication",
        steps: [
          { no: "01", title: "Guest Enquires", desc: "A guest contacts your hotel through WhatsApp with a booking question or requirement." },
          { no: "02", title: "Quick Response", desc: "The configured automation responds with the relevant information or guides the guest through the next step." },
          { no: "03", title: "Booking Confirmation", desc: "Once the booking is confirmed, the guest receives the booking details and voucher through WhatsApp." },
          { no: "04", title: "Pre-Arrival Updates", desc: "Automated reminders and important stay information can be shared before check-in." },
          { no: "05", title: "Guest Support", desc: "During the guest journey, your team can continue communication and handle requests through WhatsApp." },
          { no: "06", title: "Post-Stay Engagement", desc: "After checkout, hotels can use WhatsApp communication for feedback and future guest engagement." },
        ],
        midTagline: "More Than Just Automated Messages — A Complete Guest Communication Journey",
        midText:
          "WhatsApp automation should not simply send messages. It should help your hotel provide the right information at the right time. With Superhost Cloud, you can structure your guest communication around the complete booking journey: Enquiry → Booking → Confirmation → Voucher → Reminder → Check-in → Stay → Feedback. This creates a more consistent communication experience for both your guests and your hotel team.",
        whyHeading: "Reduce Repetitive Work for Your Hotel Team",
        whyText:
          "Your staff shouldn't have to manually send the same confirmation, voucher or reminder to every guest. Superhost Cloud helps automate repetitive communication so your team can spend more time on guest experience and hotel operations. Your team gets less repetitive messaging, faster guest communication, consistent booking information, automated booking vouchers, timely guest reminders, better organized communication and human support when required.",
        bulletsHeading: "Why Hotels Use WhatsApp Automation",
        bullets: [
          "Faster Communication — Guests get important information without waiting for manual replies.",
          "Save Staff Time — Automate repetitive messages and reduce manual communication.",
          "Meet Guests Where They Already Communicate — Keep the booking conversation on WhatsApp instead of complicated channels.",
          "Better Guest Experience — Give guests timely booking information, reminders and support throughout their stay.",
          "More Direct Booking Opportunities — A well-designed WhatsApp booking journey helps hotels handle direct enquiries more efficiently.",
        ],
        builtHeading: "The Result: Less Manual Work. Faster Communication. Better Guest Experience.",
        builtText:
          "Superhost Cloud helps hotels turn WhatsApp from a simple messaging channel into an important part of their booking and guest communication workflow.",
        closingHeading: "Ready to Automate Your Hotel's WhatsApp Communication?",
        closingText: "Automate booking confirmations, vouchers, reminders and guest communication — while keeping your hotel team in control.",
      },
      "front-office": {
        subtitle: "Run Your Hotel Front Desk Smoothly & Efficiently",
        body:
          "Superhost Cloud Front Office System helps your team manage daily front-desk operations from one centralized platform — from check-ins and check-outs to guest details, room status and housekeeping coordination.",
        heroButtons: [{ label: "Get Started", type: "primary", action: "contact" }],
        featuresHeading: "Everything Your Front Desk Needs",
        features: [
          { title: "Easy Check-In & Check-Out", desc: "Manage guest arrivals and departures quickly with an organized front-desk workflow." },
          { title: "Guest Information", desc: "Access important guest and booking details from one place." },
          { title: "Room Status Management", desc: "View room availability and status to help your team manage rooms efficiently." },
          { title: "Housekeeping Coordination", desc: "Keep track of room status and coordinate with housekeeping for faster room turnover." },
          { title: "Booking Management", desc: "View upcoming and current reservations so your front desk team always knows what is happening." },
          { title: "Billing & Payments", desc: "Manage booking charges, payments and guest billing information efficiently." },
        ],
        stepsHeading: "How It Works",
        steps: [
          { no: "01", title: "View Today's Arrivals", desc: "See guests checking in and prepare your front desk for the day." },
          { no: "02", title: "Manage Check-Ins", desc: "Access booking and guest details and complete the check-in process smoothly." },
          { no: "03", title: "Manage Room Status", desc: "Keep track of available, occupied, dirty and ready rooms." },
          { no: "04", title: "Handle Check-Outs", desc: "Complete guest check-outs and update room status for the next booking." },
        ],
        whyHeading: "One Dashboard for Your Front Desk",
        whyText:
          "Your front desk team shouldn't have to manage guest information, bookings and room status across different systems. Superhost Cloud brings essential front-office operations together in one place, helping your team work faster, stay organized and deliver a smoother guest experience.",
        bulletsHeading: "Why Hotels Use Superhost Cloud Front Office",
        bullets: [
          "Faster check-in and check-out",
          "Centralized guest information",
          "Better room visibility",
          "Easier housekeeping coordination",
          "Organized booking management",
          "Simplified daily operations",
        ],
        postTagline: "Less Manual Work. Smoother Hotel Operations.",
        closingHeading: "Make Your Front Desk Smarter",
        closingText: "Give your team the tools they need to manage daily hotel operations efficiently from one centralized platform.",
      },
      "revenue-management": {
        subtitle: "Turn Your Booking Data Into Smarter Revenue Decisions",
        body:
          "Superhost Cloud helps hotels manage bookings and make better pricing and revenue decisions using real-time business data, booking trends and property performance. From monitoring booking performance to understanding demand and room revenue, get the information you need to manage your hotel more effectively.",
        heroButtons: [{ label: "Get Started", type: "primary", action: "contact" }],
        featuresHeading: "Manage Bookings. Understand Revenue. Grow Smarter.",
        features: [
          { title: "Centralized Booking Management", desc: "View and manage bookings from different sources in one centralized system." },
          { title: "Revenue Tracking", desc: "Monitor your hotel revenue and understand how your property is performing." },
          { title: "Booking Performance", desc: "Track booking trends, sources and performance to understand where your bookings are coming from." },
          { title: "Room Revenue Management", desc: "Understand room performance and use your available data to make better pricing decisions." },
          { title: "Performance Insights", desc: "Get useful insights into bookings, revenue, occupancy and other important hotel metrics." },
          { title: "Data-Driven Decisions", desc: "Use your hotel data to make more informed decisions about pricing, inventory and revenue strategies." },
        ],
        stepsHeading: "How It Works",
        steps: [
          { no: "01", title: "Collect Your Booking Data", desc: "Bring your booking information together from your connected channels and hotel operations." },
          { no: "02", title: "Track Performance", desc: "Monitor bookings, revenue and important property metrics from your dashboard." },
          { no: "03", title: "Understand Demand", desc: "Identify booking patterns and understand how your property is performing." },
          { no: "04", title: "Make Smarter Decisions", desc: "Use your data to adjust your pricing, inventory and revenue strategy according to your business needs." },
        ],
        whyHeading: "Make Every Room Count",
        whyText:
          "Getting bookings is important — but understanding when, where and at what rate those bookings are coming from can help you make better revenue decisions. Superhost Cloud gives hotel owners a centralized view of their booking and revenue data so they can manage their business with greater clarity.",
        whyTagline: "Better Data. Smarter Decisions. Stronger Revenue Opportunities.",
        bulletsHeading: "Why Hotels Use Superhost Cloud",
        bullets: [
          "Centralized booking visibility",
          "Revenue tracking",
          "Booking source analysis",
          "Room performance insights",
          "Data-driven pricing decisions",
          "Real-time business visibility",
        ],
        closingHeading: "Ready to Manage Your Hotel's Revenue Smarter?",
        closingText: "Get better visibility into your bookings and revenue with Superhost Cloud.",
      },
      "website-development": {
        subtitle: "Build a Powerful Online Presence for Your Hotel",
        body:
          "Your hotel website is often the first place potential guests learn about your property. Superhost Cloud creates fast, modern and mobile-friendly hotel websites designed to showcase your property and make it easier for guests to enquire or book directly.",
        heroButtons: [{ label: "Get Started", type: "primary", action: "contact" }],
        featuresHeading: "Everything Your Hotel Website Needs",
        features: [
          { title: "Professional Hotel Website", desc: "Showcase your rooms, amenities, property images, location and important information in a professional layout." },
          { title: "Mobile-First Design", desc: "Give your guests a smooth browsing experience across smartphones, tablets and desktops." },
          { title: "Direct Booking Engine", desc: "Allow guests to check availability and make direct reservations through your website." },
          { title: "Commission-Free Direct Bookings", desc: "Help your hotel generate direct booking opportunities without relying only on third-party channels." },
          { title: "Fast & User-Friendly", desc: "Create a smooth website experience that makes it easy for visitors to find information and take action." },
          { title: "SEO-Friendly Structure", desc: "Build your website with a search-friendly structure to help potential guests discover your property online." },
        ],
        stepsHeading: "How We Build Your Hotel Website",
        steps: [
          { no: "01", title: "Understand Your Property", desc: "We understand your hotel, target guests, location, rooms, amenities and business requirements." },
          { no: "02", title: "Design Your Website", desc: "Create a modern website that reflects your property's brand and gives guests a premium browsing experience." },
          { no: "03", title: "Add Hotel Information", desc: "Add room details, photos, amenities, location, policies and other important property information." },
          { no: "04", title: "Integrate Direct Booking", desc: "Connect the booking engine and required systems to enable direct booking opportunities." },
          { no: "05", title: "Launch & Support", desc: "Make the website live and provide ongoing support for updates and improvements." },
        ],
        whyHeading: "Turn Website Visitors Into Direct Booking Opportunities",
        whyText:
          "Your website should do more than just display your hotel's information. Superhost Cloud creates hotel websites designed to showcase your property, build trust and make the booking journey simple for your guests.",
        whyTagline: "Your Hotel. Your Website. Your Direct Bookings.",
        bulletsHeading: "Why Hotels Choose Superhost Cloud",
        bullets: [
          "Professional hotel website",
          "Mobile-friendly design",
          "Direct booking engine",
          "Commission-free direct booking opportunities",
          "Hotel room & amenity showcase",
          "SEO-friendly structure",
          "Easy enquiry options",
          "Ongoing website support",
        ],
        closingHeading: "Ready to Build Your Hotel's Website?",
        closingText: "Give your hotel a professional online presence and make it easier for guests to book directly.",
      },
      "social-media": {
        subtitle: "Turn Your Hotel's Social Media Into a Growth Channel",
        body:
          "Your hotel deserves more than just a social media page. Superhost Cloud helps hotels build a strong social media presence through professional content, engaging campaigns and targeted digital marketing designed specifically for the hospitality industry.",
        heroButtons: [{ label: "Get Started", type: "primary", action: "contact" }],
        featuresHeading: "Build a Stronger Social Presence",
        features: [
          { title: "Professional Content", desc: "Create engaging posts, reels and stories that showcase your rooms, amenities, experiences, offers and property." },
          { title: "Targeted Campaigns", desc: "Run social media campaigns designed to reach the right audience for your hotel and location." },
          { title: "Reels & Visual Content", desc: "Create attractive short-form content that helps your property stand out and reach more potential guests." },
          { title: "Hotel Promotions", desc: "Promote seasonal offers, packages, events and special deals through your social media channels." },
          { title: "Performance Tracking", desc: "Monitor reach, engagement and campaign performance to understand what is working for your property." },
          { title: "Audience Engagement", desc: "Build stronger connections with potential and existing guests through consistent social media communication." },
        ],
        stepsHeading: "How Our Social Media Marketing Works",
        steps: [
          { no: "01", title: "Understand Your Hotel", desc: "We understand your property, location, target audience, USPs and business goals." },
          { no: "02", title: "Create Your Content Strategy", desc: "We plan content around your hotel's rooms, amenities, offers, location and guest experience." },
          { no: "03", title: "Create & Publish", desc: "Our team creates and publishes engaging posts, reels and stories across your selected social platforms." },
          { no: "04", title: "Promote Your Property", desc: "We use relevant campaigns and promotions to increase your hotel's online reach." },
          { no: "05", title: "Track & Improve", desc: "We monitor performance and continuously improve the content and campaign strategy." },
        ],
        whyHeading: "Make Your Hotel Stand Out Online",
        whyText:
          "Your guests are already spending time on social media. The goal is to make your hotel visible, attractive and memorable when they are looking for their next stay. Superhost Cloud helps you turn your social media presence into a consistent marketing channel for your hotel.",
        whyTagline: "More Visibility. Better Engagement. Stronger Hotel Brand.",
        bulletsHeading: "Why Hotels Choose Superhost Cloud",
        bullets: [
          "Hotel-focused social media strategy",
          "Professional posts & reels",
          "Social media campaigns",
          "Property & offer promotions",
          "Audience targeting",
          "Performance tracking",
          "Consistent content management",
        ],
        closingHeading: "Ready to Grow Your Hotel on Social Media?",
        closingText: "Let Superhost Cloud help you build a stronger digital presence and reach more potential guests.",
      },
      "owner-support": {
        subtitle: "Reliable Support for Your Hotel's Online Bookings",
        body:
          "Managing online bookings can involve multiple channels, booking systems, rates, availability and guest queries. Superhost Cloud provides dedicated support to help hotels manage and resolve booking-related issues smoothly.",
        heroButtons: [{ label: "Get Started", type: "primary", action: "contact" }],
        featuresHeading: "Support for Your Online Booking Operations",
        features: [
          { title: "Booking Assistance", desc: "Get help with booking-related queries, reservation details and booking issues." },
          { title: "OTA Support", desc: "Get assistance with OTA listing, booking and channel-related queries." },
          { title: "Rate & Availability Support", desc: "Get help with issues related to room rates, availability and inventory synchronization." },
          { title: "Technology Support", desc: "Get assistance with Superhost Cloud's technology, dashboard and connected systems." },
          { title: "Guest Booking Support", desc: "Resolve booking-related issues that may affect your guest experience." },
          { title: "Dedicated Assistance", desc: "Connect with a support team that understands hotel operations and online booking workflows." },
        ],
        stepsHeading: "How Our Booking Support Works",
        steps: [
          { no: "01", title: "Contact Our Team", desc: "Reach out to our support team with your booking-related issue." },
          { no: "02", title: "Share the Details", desc: "Provide the relevant booking, property or system information." },
          { no: "03", title: "Get Expert Guidance", desc: "Our team reviews the issue and guides you through the appropriate solution." },
          { no: "04", title: "Get Back to Business", desc: "Resolve the issue and continue managing your hotel operations smoothly." },
        ],
        whyHeading: "Don't Let Booking Issues Slow You Down",
        whyText:
          "Online booking problems can affect your hotel's operations and guest experience. With Superhost Cloud, you have a dedicated support team to help you navigate booking, OTA, technology and platform-related queries.",
        whyTagline: "Your Hotel. Your Bookings. Our Support.",
        bulletsHeading: "Why Hotels Choose Our Support",
        bullets: [
          "Hotel-focused support",
          "Online booking assistance",
          "OTA & channel support",
          "Rate & inventory guidance",
          "Technology assistance",
          "Human support when you need it",
        ],
        closingHeading: "Need Help With Your Online Bookings?",
        closingText: "Connect with the Superhost Cloud support team and get assistance with your hotel's online booking operations.",
      },
    },
    serviceDetail: {
      "ota-management": {
        tagline: "Be visible everywhere your guests are searching.",
        intro:
          "Superhost Cloud helps hotels set up, optimize and manage their OTA listings — including property details, room information, photos, descriptions, rates, availability and policies.",
        benefits: [
          "OTA Listing Setup – List your hotel on relevant OTA platforms",
          "Profile Optimization – Present your hotel description, amenities, room details and photos professionally",
          "Rate & Inventory Management – Keep your rates and room availability updated",
          "Content Management – Maintain accurate property information and room details",
          "Visibility Improvement – Optimize your listing for better online presence",
          "Ongoing Management – Handle required updates and changes to your OTA listings",
        ],
        points: [
          { h: "More visibility", p: "Rank higher on the platforms where 80% of hotel searches happen." },
          { h: "More bookings", p: "Optimised listings convert lookers into confirmed reservations." },
          { h: "Zero guesswork", p: "Our team handles the setup, content and photos end to end." },
        ],
      },
      "channel-management": {
        tagline: "One dashboard. Every channel. Always in sync.",
        intro:
          "Managing rates and availability across ten different OTAs by hand is how overbookings happen and revenue leaks away. Our channel manager connects every platform to a single dashboard — change a rate once and it updates everywhere in seconds.",
        benefits: [
          "Real-time sync of rates and inventory across every connected OTA",
          "Eliminate overbookings and double bookings for good",
          "Update pricing once — reflected everywhere in under 10 seconds",
          "Centralised calendar view of all your bookings in one place",
          "Push more inventory online with total confidence",
        ],
        points: [
          { h: "No overbookings", p: "Inventory updates instantly across every channel." },
          { h: "Save hours daily", p: "Stop logging into ten different extranets every morning." },
          { h: "Sell more rooms", p: "Confidently list full inventory across all channels." },
        ],
      },
      "whatsapp-automation": {
        tagline: "Meet your guests where they already are.",
        intro:
          "Your guests don't check email — they check WhatsApp. Superhost Cloud automates booking confirmations, payment reminders, check-in details and instant replies to enquiries, so no lead ever goes cold and every guest feels looked after.",
        benefits: [
          "Automated booking confirmations and pre-arrival messages",
          "Instant replies to enquiries — even after your front desk closes",
          "Payment links and reminders sent directly on WhatsApp",
          "Post-stay review requests that boost your OTA ratings",
          "Higher conversion — respond in seconds, not hours",
        ],
        points: [
          { h: "Never miss a lead", p: "Auto-reply to enquiries 24/7, even overnight." },
          { h: "Faster payments", p: "Send payment links and reminders right in chat." },
          { h: "Happier guests", p: "Timely updates guests actually open and read." },
        ],
      },
    },
    about: {
      eyebrow: "About Superhost Cloud",
      title1: "India's First & Fastest Growing AI-native Hospitality Technology Infrastructure Brand",
      title2: "— Every Accommodation's Booking & Revenue Growth Partner",
      paragraph:
        "Superhost Cloud is a hospitality technology and hotel management company built for Indian hotel owners who are tired of losing bookings to bad listings, overbookings and technology that doesn't work.",
      storyEyebrow: "Our Story",
      storyTitle: "Built by people who understand hotels",
      storyParas: [
        "We started Superhost Cloud after watching brilliant, well-run hotels struggle online — not because their rooms weren't great, but because the technology and distribution behind them was a mess.",
        "Listings were incomplete. Rates were out of sync. Enquiries went unanswered for hours. Owners were paying commissions on bookings they could have won directly. We knew there was a better way.",
        "Today we manage the online presence, bookings and technology for hotels and resorts across India — giving owners back their time, their margins and their peace of mind.",
      ],
      missionTitle: "Our Mission",
      mission:
        "To give every accommodation owner in India the technology, visibility and support that big chains take for granted — so they can compete and win on their own terms.",
      visionTitle: "Our Vision",
      vision:
        "A future where running a profitable, fully-booked accommodation doesn't require a tech team — just one trusted partner who handles it all.",
      trustTitle: "Why hotel owners trust us",
      values: [
        { h: "Owner-first", p: "Every decision we make is measured against one question: does it make more money for the hotel owner?" },
        { h: "Fast & reliable", p: "Rate changes in seconds, replies in minutes, support that actually shows up when you need it." },
        { h: "Real people", p: "A dedicated team that understands Indian hospitality — not a ticket queue." },
      ],
    },
    contact: {
      eyebrow: "Contact Us",
      title1: "LET'S TALK",
      title2: "BOOKINGS",
      paragraph:
        "Tell us about your property and we'll get back to you within 24 hours. Prefer instant? Tap the WhatsApp button.",
      whatsappBtn: "Chat on WhatsApp",
      cards: {
        whatsapp: "WhatsApp / Call",
        email: "Email",
        location: "Location",
        support: "Support",
        supportValue: "Mon–Sat, 10am–6pm IST",
      },
      formEyebrow: "Lead Form",
      formTitle: "Send us your details",
      formParagraph:
        "Fill in the form and our team will reach out with a tailored plan for your hotel. All details are stored securely.",
      whyTitle: "Why reach out?",
      whyText: "Free listing audit, a clear growth plan, and honest advice — no pressure, no jargon.",
    },
    footer: {
      tagline:
        "Hospitality technology made for Indian accommodation owners — more bookings, better visibility, effortless property management.",
      company: "Company",
      popularServices: "Popular Services",
      getInTouch: "Get in touch",
      brand: "Superhostcloud",
      chatWhatsapp: "Chat on WhatsApp",
      rights: "All rights reserved.",
      madeIn: "Made in India for Indian hospitality.",
      privacy: "Privacy Policy",
      terms: "Terms & Conditions",
    },
  },

  hi: {
    nav: { home: "होम", about: "हमारे बारे में", services: "सेवाएँ", why: "हमें क्यों चुनें", contact: "संपर्क", whatsapp: "व्हाट्सऐप करें" },
    hero: {
      badge: "हॉस्पिटैलिटी टेक्नोलॉजी, भारत के लिए बनी",
      line1: "भारत का पहला और सबसे तेज़ी से बढ़ता",
      line2: "AI-नेटिव हॉस्पिटैलिटी टेक्नोलॉजी",
      line3: "इंफ्रास्ट्रक्चर ब्रांड",
      sub: "हर एकोमोडेशन का बुकिंग और रेवेन्यू ग्रोथ पार्टनर",
      paragraph: "",
      chips: ["कोई ओवरबुकिंग नहीं", "ज़्यादा ऑनलाइन बुकिंग", "ऑनलाइन बुकिंग सपोर्ट"],
      ctaPrimary: "व्हाट्सऐप पर शुरू करें",
      ctaSecondary: "सेवाएँ देखें",
    },
    stats: {
      accommodations: "एकोमोडेशन",
      cities: "शहर",
      states: "राज्य",
      otas: "एक जगह मैनेज होने वाले OTA",
      support: "ऑनलाइन बुकिंग सपोर्ट",
    },
    servicesOverview: {
      eyebrow: "आपके होटल की हर ज़रूरत",
      title: "दस सेवाएँ। एक पार्टनर।",
      subtitle:
        "खाली कमरे, बिखरी हुई OTA लिस्टिंग, छूटी हुई पूछताछ और ओवरबुकिंग — ये हर रात आपका नुकसान करते हैं। Superhost Cloud इन सबको ठीक करता है — ताकि आपको ज़्यादा डायरेक्ट बुकिंग, बेहतर विज़िबिलिटी और एक ऐसा फ्रंट डेस्क मिले जो खुद-ब-खुद चले।",
      learnMore: "और जानें",
      viewAll: "सभी सेवाएँ देखें",
    },
    services: {
      "ota-management": {
        title: "OTA लिस्टिंग और मैनेजमेंट",
        short:
          "अपने होटल को प्रमुख OTA प्लेटफ़ॉर्म पर लिस्ट करें और अपनी ऑनलाइन उपस्थिति को प्रोफेशनली मैनेज करें।",
      },
      "channel-management": {
        title: "चैनल मैनेजमेंट",
        short:
          "एक डैशबोर्ड से हर OTA पर रेट और उपलब्धता रियल-टाइम में सिंक करें। अब कोई ओवरबुकिंग नहीं।",
      },
      "room-pricing": {
        title: "रूम पार्टिशन और प्राइसिंग",
        short:
          "स्मार्ट रूम कैटेगराइज़ेशन और डायनामिक प्राइसिंग जो डिमांड पकड़े और हर रात की कमाई बढ़ाए।",
      },
      "hotel-crm": {
        title: "होटल CRM",
        short:
          "हर मेहमान, पूछताछ और रिपीट बुकिंग एक जगह ट्रैक करें। एक बार आने वाले मेहमानों को नियमित बनाएँ।",
      },
      "whatsapp-automation": {
        title: "व्हाट्सऐप ऑटोमेशन",
        short:
          "गेस्ट बातचीत, बुकिंग कन्फ़र्मेशन, वाउचर और रिमाइंडर ऑटोमेट करें — मेहमानों को तेज़ जवाब दें और अपनी होटल टीम का बार-बार का काम कम करें।",
      },
      "front-office": {
        title: "फ्रंट ऑफिस सिस्टम",
        short:
          "शांत और तेज़ फ्रंट डेस्क — चेक-इन, चेक-आउट, फोलियो और हाउसकीपिंग बस कुछ टैप में।",
      },
      "revenue-management": {
        title: "बुकिंग और रेवेन्यू मैनेजमेंट",
        short:
          "अपना मार्केट समझें, आत्मविश्वास से प्राइस तय करें और डेटा-आधारित रणनीति से RevPAR बढ़ाएँ।",
      },
      "website-development": {
        title: "होटल वेबसाइट डेवलपमेंट",
        short:
          "तेज़, सुंदर, मोबाइल-फर्स्ट होटल वेबसाइट, जिसमें कमीशन-फ्री बुकिंग इंजन पहले से मौजूद है।",
      },
      "social-media": {
        title: "सोशल मीडिया मार्केटिंग",
        short:
          "कंटेंट, ऐड्स और कैंपेन जो आपके कमरे भरें और आपकी प्रॉपर्टी को हर स्क्रॉल में यादगार बनाएँ।",
      },
      "owner-support": {
        title: "होटल ऑनलाइन बुकिंग सपोर्ट",
        short:
          "आपके होटल की ऑनलाइन बुकिंग, OTA चैनल, रेट, इन्वेंट्री और टेक्नोलॉजी-संबंधी सवालों के लिए समर्पित सपोर्ट।",
      },
    },
    clientStrip: { trusted: "पूरे भारत के होटल और रिज़ॉर्ट का भरोसा" },
    whyChoose: {
      eyebrow: "हमें क्यों चुनें",
      title: "होटल मालिक Superhost Cloud को क्यों चुनते हैं",
      subtitle:
        "हम सिर्फ़ एक और सॉफ्टवेयर वेंडर नहीं हैं। हम वह पार्टनर हैं जो आपके कमरों को अपना समझता है — टेक्नोलॉजी, डिस्ट्रीब्यूशन और असली इंसानी सपोर्ट एक ही छत के नीचे।",
      reasons: [
        { h: "हर चीज़ के लिए एक पार्टनर", p: "OTA लिस्टिंग, चैनल मैनेजमेंट, रेवेन्यू, CRM, वेबसाइट और मार्केटिंग — दस सेवाएँ मिलकर काम करती हैं, दस अलग वेंडर के पीछे भागना नहीं पड़ता।" },
        { h: "असली इंसानी सपोर्ट", p: "एक समर्पित टीम जो सच में फ़ोन उठाती है और समझती है कि भारतीय होटल कैसे चलते हैं — कोई टिकट क़तार नहीं, कोई बॉट नहीं।" },
        { h: "भारतीय हॉस्पिटैलिटी के लिए बना", p: "8 कमरों की बुटीक स्टे से लेकर बड़े रिज़ॉर्ट तक, सब कुछ भारतीय मालिकों, मेहमानों और बुकिंग व्यवहार के अनुसार बना है।" },
        { h: "नतीजे जो आप माप सकें", p: "ज़्यादा डायरेक्ट बुकिंग, कम ओवरबुकिंग और बेहतर विज़िबिलिटी — अधिकांश मालिकों को 4–8 हफ़्तों में साफ़ बढ़त दिखती है।" },
      ],
    },
    testimonialsSection: {
      eyebrow: "असली मालिक। असली नतीजे।",
      title: "होटल मालिक जिन्होंने Superhost Cloud पर भरोसा किया",
    },
    testimonials: [
      {
        name: "Hotel Nilay",
        quote:
          "Superhost Cloud se pehle hamari online visibility kam thi aur bookings sambhalna mushkil tha. Superhost Cloud ne sab aasaan kar diya — hamare hotel ko OTAs par list karna, rates manage karna aur bookings confirm karna. Ab hamein regular bookings milti hain aur hamari online presence saaf taur par behtar hui hai. Ye hamare business ke liye bahut faydemand raha hai!",
      },
      {
        name: "The Imperial Hotel And Restaurant",
        quote:
          "Superhost Cloud ne sirf bookings me hi madad nahi ki — unhone ye pakka kiya ki hum sabhi bade OTAs par sahi rates aur real-time updates ke saath visible rahein. Mehmaan aasaani se booking kar rahe hain aur poora experience kaafi behtar ho gaya hai. Ye wakai hamare liye game-changer saabit hua hai!",
      },
      {
        name: "Vrrinda Home Stay",
        quote:
          "Pehle hum OTA ki samasyaon me ghanton lagate the. Superhost Cloud par switch karne ke baad, unki team OTA listings, rate management aur bookings sab background me sambhalti hai. Ab hum apne mehmaanon par dhyan dete hain, escalations par nahi — poori tarah se nischint!",
      },
      {
        name: "Hotel Indra Palace",
        quote:
          "Superhost Cloud ne hamari property ko aasani se OTAs par list kiya, bookings ko confirm karna aasaan kar diya aur rates ko sahi se manage kiya. Ab unki poori madad ki wajah se, hotel chalana kaafi aasaan ho gaya hai!",
      },
      {
        name: "Vaishnavi dham",
        quote:
          "Hamein pehle samajh nahi aata tha ki online platforms aur OTA listings ko kaise sambhalen. Superhost Cloud ne OTA management, rates aur bookings — sab kuch apne haath mein le liya. Ab hamein mil rahe hain pakke bookings, samay par payment aur shandar support. Wakai hamare liye badi madad saabit hui hai!",
      },
      {
        name: "P VEE Resorts",
        quote:
          "Ab hamari online presence behtar hui hai aur tension kam hua hai. Superhost Cloud ne OTA listing, rate management aur booking management tak har cheez mein madad ki. Hum poori tarah se santusht hain aur Superhost Cloud ko main sabhi hoteliyaron ko zaroor anushansa karta hun!",
      },
      {
        name: "Hotel Bandu",
        quote:
          "Nakli bookings badi samasya thin, lekin ab Superhost Cloud unhen chhankar keval pushti aur bhugtan wale atithi hi late hain. Saath hi, hamari OTA listings aur rates ab ek hi jagah se manage hote hain. Ab hamein milte hain bharosemand arakshan, samay par updates aur khush grahak. Yeh hamare liye ek bada badlav hai.",
      },
      {
        name: "Hotel Nilamber",
        quote:
          "Superhost Cloud hamare liye ek bharosemand sathi ki tarah hain. Ve OTA listing, arakshan, rate management aur atithi se judi sabhi jimmedariyan sambhalte hain, jisse hum apne mehmanon ki seva par poori tarah dhyan de pate hain.",
      },
    ],
    lead: {
      eyebrow: "मुफ़्त सलाह",
      title: "आइए आपके कमरे भरें",
      paragraph:
        "हमें अपनी प्रॉपर्टी के बारे में बताएँ। हमारी टीम आपकी ऑनलाइन उपस्थिति का ऑडिट करेगी और बताएगी कि आप ठीक कहाँ बुकिंग खो रहे हैं — पूरी तरह मुफ़्त, बिना किसी बाध्यता के।",
      bullets: [
        "मुफ़्त लिस्टिंग और चैनल ऑडिट",
        "आपके होटल के लिए अनुकूलित ग्रोथ प्लान",
        "24 घंटे के भीतर जवाब",
      ],
      whatsappPrefer: "व्हाट्सऐप पसंद है? अभी चैट करें",
    },
    form: {
      fullName: "पूरा नाम *",
      hotelName: "होटल / प्रॉपर्टी का नाम",
      mobile: "मोबाइल नंबर *",
      email: "ईमेल पता *",
      mobileInvalid: "कृपया सही 10 अंकों का मोबाइल नंबर दर्ज करें।",
      city: "शहर",
      state: "राज्य",
      other: "अन्य",
      rooms: "कमरों की संख्या",
      service: "किस सेवा में रुचि है",
      message: "संदेश / आवश्यकताएँ",
      ph: {
        name: "आपका नाम",
        property: "प्रॉपर्टी का नाम",
        mobile: "10 अंकों का नंबर",
        email: "@email.com",
        city: "शहर",
        rooms: "जैसे 24",
        select: "एक सेवा चुनें",
        selectCity: "शहर चुनें",
        selectState: "राज्य चुनें",
        selectStateFirst: "पहले राज्य चुनें",
        otherCity: "अपना शहर लिखें",
        otherState: "अपना राज्य लिखें",
        message: "बताएँ आपको क्या चाहिए...",
      },
      serviceOptions: [
        "होटल मैनेजमेंट सॉफ्टवेयर",
        "चैनल मैनेजर",
        "बुकिंग मैनेजमेंट",
        "वेबसाइट डेवलपमेंट",
        "रेवेन्यू मैनेजमेंट",
        "डिजिटल मार्केटिंग",
        "अन्य",
      ],
      submit: "पूछताछ भेजें",
      sending: "भेजा जा रहा है...",
      thankyouTitle: "धन्यवाद!",
      thankyouMsg: "हमारी टीम जल्द ही आपसे संपर्क करेगी।",
      another: "एक और पूछताछ भेजें",
      reqTitle: "कृपया ज़रूरी जानकारी भरें",
      reqDesc: "नाम, मोबाइल नंबर और ईमेल ज़रूरी हैं।",
      errTitle: "कुछ गड़बड़ हो गई",
      errDesc: "कृपया दोबारा कोशिश करें या हमें व्हाट्सऐप पर संपर्क करें।",
    },
    faqSection: { eyebrow: "सामान्य प्रश्न", title: "होटल मालिकों के सवालों के जवाब" },
    faqs: [
      {
        q: "Superhost Cloud असल में क्या करता है?",
        a: "हम एक हॉस्पिटैलिटी टेक्नोलॉजी और होटल मैनेजमेंट कंपनी हैं। OTA लिस्टिंग, चैनल मैनेजमेंट और रेवेन्यू रणनीति से लेकर व्हाट्सऐप ऑटोमेशन, CRM, वेबसाइट डेवलपमेंट और मार्केटिंग तक — सब हम संभालते हैं, ताकि होटल मालिकों को कम मेहनत में ज़्यादा बुकिंग मिले।",
      },
      {
        q: "क्या आपकी सेवाएँ इस्तेमाल करने के लिए तकनीकी जानकारी ज़रूरी है?",
        a: "बिल्कुल नहीं। हमारी टीम सब कुछ आपके लिए सेट करती है और लगातार सपोर्ट देती है। आप अपने मेहमानों पर ध्यान दें; टेक्नोलॉजी और डिस्ट्रीब्यूशन हम संभालते हैं।",
      },
      {
        q: "मुझे नतीजे कितनी जल्दी दिखेंगे?",
        a: "लिस्टिंग ऑप्टिमाइज़ होने और चैनल सही से जुड़ने के बाद अधिकांश होटल मालिकों को पहले 4–8 हफ़्तों में पूछताछ और बुकिंग में साफ़ बढ़त दिखती है।",
      },
      {
        q: "क्या आप छोटे स्वतंत्र होटलों के साथ काम करते हैं?",
        a: "हाँ। 8 कमरों की बुटीक स्टे से लेकर बड़ी प्रॉपर्टीज़ तक, हमारी सेवाएँ आपके आकार और बजट के अनुसार ढल जाती हैं।",
      },
      {
        q: "मैं शुरुआत कैसे करूँ?",
        a: "किसी भी व्हाट्सऐप बटन पर टैप करें या संपर्क फ़ॉर्म भरें। हमारी टीम आपसे संपर्क करेगी, आपकी प्रॉपर्टी समझेगी और सही प्लान सुझाएगी।",
      },
    ],
    cta: {
      homeTitle: "और कमरे भरने के लिए तैयार हैं?",
      homeSubtitle:
        "आज ही हमारी टीम से बात करें। हम आपकी लिस्टिंग का ऑडिट करेंगे और बताएँगे कि आप ठीक कहाँ बुकिंग खो रहे हैं — मुफ़्त।",
      servicesTitle: "समझ नहीं आ रहा कहाँ से शुरू करें?",
      servicesSubtitle:
        "हमें अपनी प्रॉपर्टी के बारे में बताएँ और हम आपके लक्ष्य व बजट के अनुसार सही सेवाओं का मिश्रण सुझाएँगे।",
      aboutTitle: "आइए मिलकर आपका होटल बढ़ाएँ",
      aboutSubtitle:
        "सैकड़ों भारतीय होटल मालिकों की तरह, जो अपने कमरे भरने के लिए Superhost Cloud पर भरोसा करते हैं।",
      whatsappBtn: "व्हाट्सऐप पर चैट करें",
      freeConsult: "मुफ़्त सलाह लें",
    },
    servicesPage: {
      eyebrow: "हमारी सेवाएँ",
      title1: "वह सब कुछ",
      title2: "जो आपके होटल को चाहिए",
      paragraph:
        "दस केंद्रित सेवाएँ जो मिलकर आपको ज़्यादा बुकिंग, बेहतर विज़िबिलिटी और घड़ी की तरह चलने वाला होटल देती हैं।",
      learnMore: "और जानें",
      enquire: "पूछताछ करें",
    },
    sdUI: {
      allServices: "सभी सेवाएँ",
      talkWhatsapp: "व्हाट्सऐप पर बात करें",
      overview: "अवलोकन",
      whatItDoes: "यह आपके लिए क्या करता है",
      benefitsTitle: "होटल मालिकों के लिए फ़ायदे",
      getFreeConsult: "मुफ़्त सलाह लें",
      notFound: "सेवा नहीं मिली",
      back: "सेवाओं पर वापस जाएँ",
      getStarted: "शुरू करें",
      talkExpert: "विशेषज्ञ से बात करें",
      enquireNow: "अभी पूछताछ करें",
      waLead: "नमस्ते Superhost Cloud, मुझे",
      waTail: " के बारे में और जानकारी चाहिए।",
    },
    richServiceDetail: {
      "channel-management": {
        subtitle: "अपने सभी होटल बुकिंग चैनल एक ही जगह से मैनेज करें",
        body:
          "कई OTA प्लेटफ़ॉर्म को मैन्युअल रूप से मैनेज करना समय लेने वाला हो सकता है और इससे रेट में गड़बड़ी, इन्वेंट्री की ग़लतियाँ और ओवरबुकिंग हो सकती है। Superhost Cloud चैनल मैनेजमेंट होटलों को उनके जुड़े हुए बुकिंग चैनल एक ही सेंट्रलाइज़्ड डैशबोर्ड से मैनेज करने में मदद करता है, जिससे रेट, उपलब्धता, रूम इन्वेंट्री और बुकिंग को कंट्रोल करना आसान हो जाता है।",
        featuresHeading: "एक डैशबोर्ड। कई बुकिंग चैनल।",
        featuresIntro:
          "आपके होटल को कई ऑनलाइन चैनलों से बुकिंग मिल सकती है। हर प्लेटफ़ॉर्म को अलग-अलग मैनेज करने के बजाय, Superhost Cloud आपके चैनल मैनेजमेंट को एक ही जगह ले आता है।",
        features: [
          { title: "रेट सिंक्रोनाइज़ेशन", desc: "अपने रूम रेट को जुड़े हुए बुकिंग चैनलों पर कुशलता से अपडेट करें।" },
          { title: "उपलब्धता प्रबंधन", desc: "रूम उपलब्धता को एक ही सेंट्रलाइज़्ड सिस्टम से मैनेज करें।" },
          { title: "इन्वेंट्री प्रबंधन", desc: "अपनी रूम इन्वेंट्री को जुड़े हुए चैनलों पर व्यवस्थित और सिंक रखें।" },
          { title: "बुकिंग प्रबंधन", desc: "अपने जुड़े हुए चैनलों से मिली बुकिंग देखें और मैनेज करें।" },
          { title: "ओवरबुकिंग का जोखिम कम करें", desc: "जुड़े हुए चैनलों पर इन्वेंट्री अपडेट रखकर एक ही रूम दो बार बिकने की संभावना कम करें।" },
          { title: "सेंट्रलाइज़्ड रेट कंट्रोल", desc: "अपनी रूम प्राइसिंग एक जगह से मैनेज करें और डिस्ट्रिब्यूशन पर बेहतर नियंत्रण रखें।" },
        ],
        stepsHeading: "चैनल मैनेजमेंट कैसे काम करता है",
        steps: [
          { no: "01", title: "अपने चैनल कनेक्ट करें", desc: "अपने सपोर्टेड OTA और बुकिंग चैनल को Superhost Cloud से कनेक्ट करें।" },
          { no: "02", title: "एक डैशबोर्ड से मैनेज करें", desc: "रेट, उपलब्धता और इन्वेंट्री को एक सेंट्रलाइज़्ड डैशबोर्ड से कंट्रोल करें।" },
          { no: "03", title: "अपनी इन्वेंट्री सिंक करें", desc: "आपके रेट और उपलब्धता में किए गए बदलाव जुड़े हुए चैनलों के साथ सिंक हो जाते हैं।" },
          { no: "04", title: "अपनी बुकिंग मैनेज करें", desc: "जुड़े हुए चैनलों से बुकिंग देखें और अपने होटल ऑपरेशन एक ही सिस्टम से मैनेज करें।" },
        ],
        whyHeading: "Superhost Cloud क्यों चुनें?",
        whySub: "कई चैनलों को मैन्युअल रूप से मैनेज करना बंद करें",
        whyText:
          "अलग-अलग OTA डैशबोर्ड के बीच स्विच करना क़ीमती समय ले सकता है और मैन्युअल ग़लतियों की संभावना बढ़ाता है। Superhost Cloud आपके होटल को एक सेंट्रलाइज़्ड चैनल मैनेजमेंट समाधान देता है जो आपके ऑनलाइन डिस्ट्रिब्यूशन को आसान बनाने के लिए डिज़ाइन किया गया है।",
        bulletsIntro: "Superhost Cloud के साथ, आप कर सकते हैं:",
        bullets: [
          "कई चैनल एक ही जगह से मैनेज करें",
          "रूम उपलब्धता व्यवस्थित रखें",
          "रेट कुशलता से मैनेज करें",
          "बुकिंग जानकारी सेंट्रलाइज़ करें",
          "बार-बार होने वाले मैन्युअल अपडेट कम करें",
          "अपनी ऑनलाइन इन्वेंट्री पर बेहतर नियंत्रण पाएँ",
        ],
        builtHeading: "आधुनिक होटलों के लिए बना",
        builtText:
          "चाहे आप छोटा होटल, बुटीक प्रॉपर्टी, रिज़ॉर्ट, होमस्टे या कई प्रॉपर्टी मैनेज करते हों, सेंट्रलाइज़्ड चैनल मैनेजमेंट आपके रोज़ाना के काम को आसान बना सकता है। प्लेटफ़ॉर्म मैनेज करने में कम समय लगाएँ। अपने होटल को बढ़ाने में ज़्यादा समय दें।",
      },
      "room-pricing": {
        subtitle: "अपने कमरों को बेहतर तरीक़े से मैनेज करें",
        body: "एक ही सेंट्रलाइज़्ड सिस्टम से अलग-अलग रूम कैटेगरी बनाएँ और मैनेज करें।",
        features: [
          { title: "रूम कैटेगराइज़ेशन", desc: "रूम साइज़, ऑक्युपेंसी, सुविधाओं, व्यू और अन्य फ़ीचर के आधार पर अलग रूम टाइप बनाएँ।" },
          { title: "लचीली रूम प्राइसिंग", desc: "अलग-अलग रूम कैटेगरी और प्राइसिंग ज़रूरतों के लिए अलग रेट सेट करें।" },
          { title: "बेहतर रेवेन्यू कंट्रोल", desc: "अपनी रूम कैटेगरी और प्राइसिंग स्ट्रक्चर समझकर बेहतर रेवेन्यू फ़ैसले लें।" },
          { title: "ऑक्युपेंसी-आधारित प्राइसिंग", desc: "गेस्ट ऑक्युपेंसी और रूम ज़रूरतों के अनुसार प्राइसिंग मैनेज करें।" },
          { title: "तारीख़-आधारित रेट", desc: "अलग-अलग तारीख़ों, सीज़न या माँग के अनुसार अलग क़ीमतें सेट करें।" },
          { title: "आसान रेट मैनेजमेंट", desc: "रूम रेट अपडेट करें और अपना प्राइसिंग स्ट्रक्चर एक ही जगह से मैनेज करें।" },
        ],
        stepsHeading: "यह कैसे काम करता है",
        steps: [
          { no: "01", title: "रूम कैटेगरी बनाएँ", desc: "अपने रूम टाइप तय करें जैसे स्टैंडर्ड, डीलक्स, प्रीमियम, सुइट आदि।" },
          { no: "02", title: "रूम विवरण जोड़ें", desc: "ऑक्युपेंसी, सुविधाएँ, रूम संख्या और अन्य ज़रूरी विवरण जोड़ें।" },
          { no: "03", title: "अपनी प्राइसिंग सेट करें", desc: "अपनी रूम कैटेगरी और बिज़नेस ज़रूरतों के अनुसार रेट कॉन्फ़िगर करें।" },
          { no: "04", title: "मैनेज और अपडेट करें", desc: "जब भी ज़रूरत हो, प्राइसिंग और रूम में बदलाव करें।" },
        ],
        whyHeading: "स्मार्ट रूम प्राइसिंग क्यों ज़रूरी है",
        whyText:
          "अलग कमरों की अलग वैल्यू होती है, इसलिए हर कमरे के लिए एक जैसी प्राइसिंग रखना हमेशा सही नहीं होता। Superhost Cloud के साथ आप अपनी रूम कैटेगरी और प्राइसिंग को ज़्यादा प्रभावी तरीक़े से व्यवस्थित कर सकते हैं, जिससे आपकी इन्वेंट्री और रेवेन्यू रणनीति पर बेहतर नियंत्रण बना रहता है।",
        whyTagline: "सही कमरा। सही क़ीमत। बेहतर रेवेन्यू अवसर।",
        builtHeading: "बढ़ते होटलों के लिए बना",
        builtText:
          "चाहे आप होटल, रिज़ॉर्ट, बुटीक प्रॉपर्टी या होमस्टे मैनेज करते हों, Superhost Cloud आपकी रूम कैटेगरी और प्राइसिंग को एक सरल और सेंट्रलाइज़्ड सिस्टम में व्यवस्थित करने में मदद करता है।",
        closingHeading: "अपने कमरों को स्मार्ट तरीक़े से मैनेज करने के लिए तैयार हैं?",
        closingText: "बेहतर रूम कैटेगरी बनाएँ। प्राइसिंग कुशलता से मैनेज करें। स्मार्ट रेवेन्यू रणनीति बनाएँ।",
      },
      "hotel-crm": {
        subtitle: "मज़बूत गेस्ट रिश्ते बनाएँ और रिपीट बुकिंग बढ़ाएँ",
        body:
          "Superhost Cloud होटल CRM आपको गेस्ट जानकारी, पूछताछ, बुकिंग इतिहास और ग्राहक बातचीत को एक ही सेंट्रलाइज़्ड प्लेटफ़ॉर्म से मैनेज करने में मदद करता है। अपने मेहमानों को बेहतर समझें, पूछताछ पर फ़ॉलो-अप करें और पुराने ग्राहकों से जुड़े रहकर रिपीट बुकिंग के ज़्यादा अवसर बनाएँ।",
        heroButtons: [{ label: "अभी पूछताछ करें", type: "primary", action: "contact" }],
        featuresHeading: "अपने गेस्ट रिश्ते एक ही जगह मैनेज करें",
        features: [
          { title: "सेंट्रलाइज़्ड गेस्ट डेटाबेस", desc: "ज़रूरी गेस्ट जानकारी एक जगह स्टोर और व्यवस्थित करें ताकि पहुँच और प्रबंधन आसान हो।" },
          { title: "गेस्ट बुकिंग इतिहास", desc: "पिछली ठहर और बुकिंग जानकारी देखें ताकि आप अपने लौटने वाले मेहमानों को बेहतर समझ सकें।" },
          { title: "पूछताछ प्रबंधन", desc: "गेस्ट पूछताछ और फ़ॉलो-अप का ट्रैक रखें ताकि संभावित बुकिंग छूट न जाए।" },
          { title: "रिपीट गेस्ट प्रबंधन", desc: "लौटने वाले मेहमानों को पहचानें और उनके बुकिंग इतिहास को बनाए रखें ताकि अनुभव ज़्यादा व्यक्तिगत हो।" },
          { title: "गेस्ट कम्युनिकेशन", desc: "अपनी गेस्ट बातचीत व्यवस्थित रखें और फ़ॉलो-अप आसान बनाएँ।" },
          { title: "गेस्ट इनसाइट्स", desc: "गेस्ट और बुकिंग जानकारी का उपयोग करके ग्राहक पैटर्न समझें और बेहतर बिज़नेस फ़ैसले लें।" },
        ],
        stepsHeading: "होटल CRM कैसे काम करता है",
        steps: [
          { no: "01", title: "गेस्ट जानकारी कैप्चर करें", desc: "अपनी पूछताछ और बुकिंग से गेस्ट विवरण इकट्ठा और व्यवस्थित करें।" },
          { no: "02", title: "हर बातचीत ट्रैक करें", desc: "ज़रूरी गेस्ट बातचीत, पूछताछ और फ़ॉलो-अप व्यवस्थित रखें।" },
          { no: "03", title: "गेस्ट इतिहास समझें", desc: "ज़रूरत पड़ने पर पिछली बुकिंग और ठहर की जानकारी तक पहुँचें।" },
          { no: "04", title: "लंबे रिश्ते बनाएँ", desc: "अपने मेहमानों से जुड़े रहें और रिपीट बुकिंग के अवसर बनाएँ।" },
        ],
        whyHeading: "एक बार के मेहमानों को लौटने वाले मेहमानों में बदलें",
        whyText:
          "गेस्ट रिश्ता चेक-आउट के बाद ख़त्म नहीं होना चाहिए। Superhost Cloud होटल CRM के साथ आप अपनी गेस्ट जानकारी और बुकिंग इतिहास व्यवस्थित रख सकते हैं, जिससे अपने ग्राहकों को समझना और लंबे रिश्ते बनाना आसान हो जाता है।",
        whyTagline: "अपने मेहमानों को जानें। जुड़े रहें। रिपीट बुकिंग बढ़ाएँ।",
        builtHeading: "होटलों को CRM की ज़रूरत क्यों है",
        builtText:
          "गेस्ट जानकारी को नोटबुक, स्प्रेडशीट, WhatsApp चैट और अलग-अलग सिस्टम में मैनेज करना फ़ॉलो-अप को मुश्किल बना सकता है। Superhost Cloud आपकी गेस्ट-संबंधी जानकारी को एक सेंट्रलाइज़्ड सिस्टम में लाता है, जिससे आपकी टीम व्यवस्थित रहती है और ग्राहक रिश्ते ज़्यादा कुशलता से मैनेज होते हैं।",
        closingHeading: "बेहतर गेस्ट रिश्ते बनाने के लिए तैयार हैं?",
        closingText: "गेस्ट जानकारी, पूछताछ और बुकिंग इतिहास एक ही सेंट्रलाइज़्ड होटल CRM से मैनेज करें।",
      },
      "whatsapp-automation": {
        subtitle: "हर गेस्ट बातचीत को एक बेहतर बुकिंग अनुभव में बदलें",
        body:
          "Superhost Cloud WhatsApp ऑटोमेशन होटलों को ऑटोमेटेड बुकिंग कन्फ़र्मेशन, वाउचर, रिमाइंडर और गेस्ट सपोर्ट के ज़रिए मेहमानों से तेज़ और ज़्यादा कुशलता से कम्युनिकेट करने में मदद करता है। जिस पल मेहमान पूछताछ करता है से लेकर उसके ठहरने के पूरा होने तक, आपका होटल ज़रूरी कम्युनिकेशन को व्यवस्थित और समय पर रख सकता है — सीधे WhatsApp पर।",
        aiConcierge: {
          eyebrow: "WhatsApp AI कॉन्सियर्ज",
          heading: "24/7 AI-संचालित गेस्ट कम्युनिकेशन",
          intro:
            "आधुनिक होटल ऑपरेशन के लिए डिज़ाइन किए गए AI-संचालित WhatsApp कॉन्सियर्ज के साथ अपने मेहमानों को तुरंत सहायता दें।",
          points: [
            { title: "24/7 गेस्ट सपोर्ट", desc: "दिन हो या रात, कभी भी गेस्ट सवालों का जवाब दें।" },
            { title: "17-सेकंड औसत जवाब", desc: "आम गेस्ट पूछताछ का तेज़ जवाब दें।" },
            { title: "हिंदी और अंग्रेज़ी सपोर्ट", desc: "मेहमानों से हिंदी और अंग्रेज़ी दोनों में बात करें।" },
            { title: "ऑटोमेटेड गेस्ट कम्युनिकेशन", desc: "बुकिंग पूछताछ, कन्फ़र्मेशन, रिमाइंडर और गेस्ट सहायता को WhatsApp के ज़रिए सुव्यवस्थित करें।" },
          ],
          footer: "Superhost Cloud के साथ, आपका होटल मेहमानों से जुड़ा रहता है — तब भी जब आपकी टीम व्यस्त हो।",
        },
        featuresHeading: "आपके होटल का कम्युनिकेशन, ऑटोमेटेड",
        featuresIntro:
          "होटलों को रोज़ एक जैसे मैसेज मिलते हैं — बुकिंग कन्फ़र्मेशन, वाउचर अनुरोध, चेक-इन सवाल, रिमाइंडर और सामान्य प्रॉपर्टी पूछताछ। हर मैसेज को मैन्युअल रूप से संभालने के बजाय, Superhost Cloud बार-बार होने वाले कम्युनिकेशन को ऑटोमेट करने में मदद करता है और आपके मेहमानों को सूचित रखता है।",
        features: [
          { title: "तुरंत गेस्ट जवाब", desc: "आम गेस्ट सवालों का तेज़ी से जवाब दें और अपने मेहमानों को फ्रंट डेस्क के जवाब का इंतज़ार करने से बचाएँ।" },
          { title: "ऑटोमेटेड बुकिंग कन्फ़र्मेशन", desc: "बुकिंग कन्फ़र्म होते ही, संबंधित बुकिंग जानकारी मेहमान को WhatsApp पर अपने-आप भेजें।" },
          { title: "WhatsApp पर बुकिंग वाउचर", desc: "मेहमान को उनका बुकिंग वाउचर और रिज़र्वेशन विवरण सीधे WhatsApp के ज़रिए भेजें।" },
          { title: "ऑटोमेटेड रिमाइंडर", desc: "मेहमान की ठहर से पहले समय पर रिमाइंडर और ज़रूरी जानकारी भेजें।" },
          { title: "प्री-अराइवल कम्युनिकेशन", desc: "आगमन से पहले चेक-इन विवरण, प्रॉपर्टी जानकारी और अन्य कॉन्फ़िगर किए गए निर्देश जैसी उपयोगी जानकारी शेयर करें।" },
          { title: "ह्यूमन हैंडओवर", desc: "जब किसी बातचीत में व्यक्तिगत सहायता की ज़रूरत हो, तो होटल टीम बातचीत संभालकर मेहमान से बात जारी रख सकती है।" },
        ],
        stepsHeading: "पूछताछ से गेस्ट कम्युनिकेशन तक",
        steps: [
          { no: "01", title: "मेहमान पूछताछ करता है", desc: "एक मेहमान बुकिंग सवाल या ज़रूरत के साथ WhatsApp के ज़रिए आपके होटल से संपर्क करता है।" },
          { no: "02", title: "त्वरित जवाब", desc: "कॉन्फ़िगर किया गया ऑटोमेशन संबंधित जानकारी के साथ जवाब देता है या मेहमान को अगले क़दम की ओर मार्गदर्शन देता है।" },
          { no: "03", title: "बुकिंग कन्फ़र्मेशन", desc: "बुकिंग कन्फ़र्म होते ही, मेहमान को बुकिंग विवरण और वाउचर WhatsApp के ज़रिए मिलता है।" },
          { no: "04", title: "प्री-अराइवल अपडेट", desc: "चेक-इन से पहले ऑटोमेटेड रिमाइंडर और ज़रूरी ठहर जानकारी शेयर की जा सकती है।" },
          { no: "05", title: "गेस्ट सपोर्ट", desc: "गेस्ट यात्रा के दौरान, आपकी टीम WhatsApp के ज़रिए कम्युनिकेशन जारी रख सकती है और अनुरोध संभाल सकती है।" },
          { no: "06", title: "पोस्ट-स्टे एंगेजमेंट", desc: "चेक-आउट के बाद, होटल फ़ीडबैक और भविष्य के गेस्ट जुड़ाव के लिए WhatsApp कम्युनिकेशन का उपयोग कर सकते हैं।" },
        ],
        midTagline: "सिर्फ़ ऑटोमेटेड मैसेज से कहीं ज़्यादा — एक संपूर्ण गेस्ट कम्युनिकेशन यात्रा",
        midText:
          "WhatsApp ऑटोमेशन को सिर्फ़ मैसेज नहीं भेजने चाहिए। इसे आपके होटल को सही समय पर सही जानकारी देने में मदद करनी चाहिए। Superhost Cloud के साथ, आप अपने गेस्ट कम्युनिकेशन को पूरी बुकिंग यात्रा के आसपास व्यवस्थित कर सकते हैं: पूछताछ → बुकिंग → कन्फ़र्मेशन → वाउचर → रिमाइंडर → चेक-इन → ठहर → फ़ीडबैक। इससे आपके मेहमानों और आपकी होटल टीम दोनों के लिए एक ज़्यादा सुसंगत कम्युनिकेशन अनुभव बनता है।",
        whyHeading: "अपनी होटल टीम का बार-बार का काम कम करें",
        whyText:
          "आपके स्टाफ़ को हर मेहमान को एक ही कन्फ़र्मेशन, वाउचर या रिमाइंडर मैन्युअल रूप से नहीं भेजना चाहिए। Superhost Cloud बार-बार होने वाले कम्युनिकेशन को ऑटोमेट करने में मदद करता है ताकि आपकी टीम गेस्ट अनुभव और होटल ऑपरेशन पर ज़्यादा समय दे सके। आपकी टीम को मिलता है — कम दोहराव वाला मैसेजिंग, तेज़ गेस्ट कम्युनिकेशन, सुसंगत बुकिंग जानकारी, ऑटोमेटेड बुकिंग वाउचर, समय पर गेस्ट रिमाइंडर, बेहतर व्यवस्थित कम्युनिकेशन और ज़रूरत पड़ने पर इंसानी सपोर्ट।",
        bulletsHeading: "होटल WhatsApp ऑटोमेशन का उपयोग क्यों करते हैं",
        bullets: [
          "तेज़ कम्युनिकेशन — मेहमानों को मैन्युअल जवाब का इंतज़ार किए बिना ज़रूरी जानकारी मिलती है।",
          "स्टाफ़ का समय बचाएँ — बार-बार होने वाले मैसेज ऑटोमेट करें और मैन्युअल कम्युनिकेशन कम करें।",
          "मेहमानों तक वहीं पहुँचें जहाँ वे पहले से कम्युनिकेट करते हैं — बुकिंग बातचीत जटिल चैनलों के बजाय WhatsApp पर रखें।",
          "बेहतर गेस्ट अनुभव — मेहमानों को उनकी ठहर भर समय पर बुकिंग जानकारी, रिमाइंडर और सपोर्ट दें।",
          "ज़्यादा डायरेक्ट बुकिंग अवसर — एक अच्छी तरह डिज़ाइन की गई WhatsApp बुकिंग यात्रा होटलों को डायरेक्ट पूछताछ ज़्यादा कुशलता से संभालने में मदद करती है।",
        ],
        builtHeading: "नतीजा: कम मैन्युअल काम। तेज़ कम्युनिकेशन। बेहतर गेस्ट अनुभव।",
        builtText:
          "Superhost Cloud होटलों को WhatsApp को एक साधारण मैसेजिंग चैनल से उनके बुकिंग और गेस्ट कम्युनिकेशन वर्कफ़्लो का एक ज़रूरी हिस्सा बनाने में मदद करता है।",
        closingHeading: "अपने होटल का WhatsApp कम्युनिकेशन ऑटोमेट करने के लिए तैयार हैं?",
        closingText: "बुकिंग कन्फ़र्मेशन, वाउचर, रिमाइंडर और गेस्ट कम्युनिकेशन ऑटोमेट करें — और अपनी होटल टीम को नियंत्रण में रखें।",
      },
      "front-office": {
        subtitle: "अपने होटल फ्रंट डेस्क को सहज और कुशलता से चलाएँ",
        body:
          "Superhost Cloud फ्रंट ऑफ़िस सिस्टम आपकी टीम को रोज़ाना के फ्रंट-डेस्क ऑपरेशन एक ही सेंट्रलाइज़्ड प्लेटफ़ॉर्म से मैनेज करने में मदद करता है — चेक-इन और चेक-आउट से लेकर गेस्ट विवरण, रूम स्टेटस और हाउसकीपिंग समन्वय तक।",
        heroButtons: [{ label: "शुरू करें", type: "primary", action: "contact" }],
        featuresHeading: "आपके फ्रंट डेस्क के लिए ज़रूरी सब कुछ",
        features: [
          { title: "आसान चेक-इन और चेक-आउट", desc: "व्यवस्थित फ्रंट-डेस्क वर्कफ़्लो से गेस्ट के आने-जाने को तेज़ी से मैनेज करें।" },
          { title: "गेस्ट जानकारी", desc: "ज़रूरी गेस्ट और बुकिंग विवरण एक ही जगह से पाएँ।" },
          { title: "रूम स्टेटस प्रबंधन", desc: "रूम उपलब्धता और स्टेटस देखें ताकि आपकी टीम कमरों को कुशलता से मैनेज कर सके।" },
          { title: "हाउसकीपिंग समन्वय", desc: "रूम स्टेटस ट्रैक करें और तेज़ रूम टर्नओवर के लिए हाउसकीपिंग के साथ समन्वय करें।" },
          { title: "बुकिंग प्रबंधन", desc: "आने वाली और मौजूदा रिज़र्वेशन देखें ताकि आपकी फ्रंट डेस्क टीम हमेशा जानती रहे क्या हो रहा है।" },
          { title: "बिलिंग और पेमेंट", desc: "बुकिंग चार्ज, पेमेंट और गेस्ट बिलिंग जानकारी कुशलता से मैनेज करें।" },
        ],
        stepsHeading: "यह कैसे काम करता है",
        steps: [
          { no: "01", title: "आज के अराइवल देखें", desc: "चेक-इन कर रहे मेहमानों को देखें और अपने फ्रंट डेस्क को दिन के लिए तैयार करें।" },
          { no: "02", title: "चेक-इन मैनेज करें", desc: "बुकिंग और गेस्ट विवरण तक पहुँचें और चेक-इन प्रक्रिया सहजता से पूरी करें।" },
          { no: "03", title: "रूम स्टेटस मैनेज करें", desc: "उपलब्ध, ऑक्युपाइड, गंदे और तैयार कमरों का ट्रैक रखें।" },
          { no: "04", title: "चेक-आउट संभालें", desc: "गेस्ट चेक-आउट पूरा करें और अगली बुकिंग के लिए रूम स्टेटस अपडेट करें।" },
        ],
        whyHeading: "आपके फ्रंट डेस्क के लिए एक डैशबोर्ड",
        whyText:
          "आपकी फ्रंट डेस्क टीम को गेस्ट जानकारी, बुकिंग और रूम स्टेटस अलग-अलग सिस्टम में मैनेज नहीं करना चाहिए। Superhost Cloud ज़रूरी फ्रंट-ऑफ़िस ऑपरेशन को एक जगह ले आता है, जिससे आपकी टीम तेज़ी से काम करती है, व्यवस्थित रहती है और एक सहज गेस्ट अनुभव देती है।",
        bulletsHeading: "होटल Superhost Cloud फ्रंट ऑफ़िस का उपयोग क्यों करते हैं",
        bullets: [
          "तेज़ चेक-इन और चेक-आउट",
          "सेंट्रलाइज़्ड गेस्ट जानकारी",
          "बेहतर रूम विज़िबिलिटी",
          "आसान हाउसकीपिंग समन्वय",
          "व्यवस्थित बुकिंग प्रबंधन",
          "सरल रोज़ाना ऑपरेशन",
        ],
        postTagline: "कम मैन्युअल काम। सहज होटल ऑपरेशन।",
        closingHeading: "अपने फ्रंट डेस्क को स्मार्ट बनाएँ",
        closingText: "अपनी टीम को वे टूल दें जिनकी उन्हें रोज़ाना के होटल ऑपरेशन एक सेंट्रलाइज़्ड प्लेटफ़ॉर्म से कुशलता से मैनेज करने के लिए ज़रूरत है।",
      },
      "revenue-management": {
        subtitle: "अपने बुकिंग डेटा को स्मार्ट रेवेन्यू फ़ैसलों में बदलें",
        body:
          "Superhost Cloud होटलों को बुकिंग मैनेज करने और रियल-टाइम बिज़नेस डेटा, बुकिंग ट्रेंड और प्रॉपर्टी प्रदर्शन का उपयोग करके बेहतर प्राइसिंग और रेवेन्यू फ़ैसले लेने में मदद करता है। बुकिंग प्रदर्शन की निगरानी से लेकर माँग और रूम रेवेन्यू समझने तक, अपने होटल को ज़्यादा प्रभावी ढंग से मैनेज करने के लिए ज़रूरी जानकारी पाएँ।",
        heroButtons: [{ label: "शुरू करें", type: "primary", action: "contact" }],
        featuresHeading: "बुकिंग मैनेज करें। रेवेन्यू समझें। स्मार्ट तरीक़े से बढ़ें।",
        features: [
          { title: "सेंट्रलाइज़्ड बुकिंग प्रबंधन", desc: "अलग-अलग स्रोतों से बुकिंग को एक ही सेंट्रलाइज़्ड सिस्टम में देखें और मैनेज करें।" },
          { title: "रेवेन्यू ट्रैकिंग", desc: "अपने होटल रेवेन्यू की निगरानी करें और समझें कि आपकी प्रॉपर्टी कैसा प्रदर्शन कर रही है।" },
          { title: "बुकिंग प्रदर्शन", desc: "बुकिंग ट्रेंड, स्रोत और प्रदर्शन ट्रैक करें ताकि समझ सकें कि आपकी बुकिंग कहाँ से आ रही है।" },
          { title: "रूम रेवेन्यू प्रबंधन", desc: "रूम प्रदर्शन समझें और अपने उपलब्ध डेटा का उपयोग करके बेहतर प्राइसिंग फ़ैसले लें।" },
          { title: "प्रदर्शन इनसाइट्स", desc: "बुकिंग, रेवेन्यू, ऑक्युपेंसी और अन्य ज़रूरी होटल मेट्रिक्स की उपयोगी इनसाइट्स पाएँ।" },
          { title: "डेटा-आधारित फ़ैसले", desc: "प्राइसिंग, इन्वेंट्री और रेवेन्यू रणनीति के बारे में ज़्यादा सूचित फ़ैसले लेने के लिए अपने होटल डेटा का उपयोग करें।" },
        ],
        stepsHeading: "यह कैसे काम करता है",
        steps: [
          { no: "01", title: "अपना बुकिंग डेटा इकट्ठा करें", desc: "अपने जुड़े हुए चैनलों और होटल ऑपरेशन से बुकिंग जानकारी एक साथ लाएँ।" },
          { no: "02", title: "प्रदर्शन ट्रैक करें", desc: "अपने डैशबोर्ड से बुकिंग, रेवेन्यू और ज़रूरी प्रॉपर्टी मेट्रिक्स की निगरानी करें।" },
          { no: "03", title: "माँग समझें", desc: "बुकिंग पैटर्न पहचानें और समझें कि आपकी प्रॉपर्टी कैसा प्रदर्शन कर रही है।" },
          { no: "04", title: "स्मार्ट फ़ैसले लें", desc: "अपने बिज़नेस की ज़रूरतों के अनुसार प्राइसिंग, इन्वेंट्री और रेवेन्यू रणनीति समायोजित करने के लिए अपने डेटा का उपयोग करें।" },
        ],
        whyHeading: "हर कमरे को मायने दें",
        whyText:
          "बुकिंग मिलना ज़रूरी है — लेकिन यह समझना कि बुकिंग कब, कहाँ और किस रेट पर आ रही है, आपको बेहतर रेवेन्यू फ़ैसले लेने में मदद करता है। Superhost Cloud होटल मालिकों को उनके बुकिंग और रेवेन्यू डेटा का सेंट्रलाइज़्ड व्यू देता है ताकि वे अपने बिज़नेस को ज़्यादा स्पष्टता से मैनेज कर सकें।",
        whyTagline: "बेहतर डेटा। स्मार्ट फ़ैसले। मज़बूत रेवेन्यू अवसर।",
        bulletsHeading: "होटल Superhost Cloud का उपयोग क्यों करते हैं",
        bullets: [
          "सेंट्रलाइज़्ड बुकिंग विज़िबिलिटी",
          "रेवेन्यू ट्रैकिंग",
          "बुकिंग स्रोत विश्लेषण",
          "रूम प्रदर्शन इनसाइट्स",
          "डेटा-आधारित प्राइसिंग फ़ैसले",
          "रियल-टाइम बिज़नेस विज़िबिलिटी",
        ],
        closingHeading: "अपने होटल का रेवेन्यू स्मार्ट तरीक़े से मैनेज करने के लिए तैयार हैं?",
        closingText: "Superhost Cloud के साथ अपनी बुकिंग और रेवेन्यू में बेहतर विज़िबिलिटी पाएँ।",
      },
      "website-development": {
        subtitle: "अपने होटल के लिए एक दमदार ऑनलाइन उपस्थिति बनाएँ",
        body:
          "आपकी होटल वेबसाइट अक्सर वह पहली जगह होती है जहाँ संभावित मेहमान आपकी प्रॉपर्टी के बारे में जानते हैं। Superhost Cloud तेज़, आधुनिक और मोबाइल-फ्रेंडली होटल वेबसाइट बनाता है जो आपकी प्रॉपर्टी को दिखाने और मेहमानों के लिए सीधे पूछताछ या बुकिंग करना आसान बनाने के लिए डिज़ाइन की गई हैं।",
        heroButtons: [{ label: "शुरू करें", type: "primary", action: "contact" }],
        featuresHeading: "आपकी होटल वेबसाइट के लिए ज़रूरी सब कुछ",
        features: [
          { title: "प्रोफ़ेशनल होटल वेबसाइट", desc: "अपने कमरे, सुविधाएँ, प्रॉपर्टी इमेज, लोकेशन और ज़रूरी जानकारी एक प्रोफ़ेशनल लेआउट में दिखाएँ।" },
          { title: "मोबाइल-फर्स्ट डिज़ाइन", desc: "अपने मेहमानों को स्मार्टफ़ोन, टैबलेट और डेस्कटॉप पर सहज ब्राउज़िंग अनुभव दें।" },
          { title: "डायरेक्ट बुकिंग इंजन", desc: "मेहमानों को आपकी वेबसाइट से उपलब्धता जाँचने और सीधी रिज़र्वेशन करने की सुविधा दें।" },
          { title: "कमीशन-फ्री डायरेक्ट बुकिंग", desc: "केवल थर्ड-पार्टी चैनलों पर निर्भर हुए बिना अपने होटल के लिए डायरेक्ट बुकिंग अवसर बनाएँ।" },
          { title: "तेज़ और यूज़र-फ्रेंडली", desc: "एक सहज वेबसाइट अनुभव बनाएँ जिससे विज़िटर के लिए जानकारी पाना और कार्रवाई करना आसान हो।" },
          { title: "SEO-फ्रेंडली स्ट्रक्चर", desc: "अपनी वेबसाइट को सर्च-फ्रेंडली स्ट्रक्चर के साथ बनाएँ ताकि संभावित मेहमान आपकी प्रॉपर्टी ऑनलाइन खोज सकें।" },
        ],
        stepsHeading: "हम आपकी होटल वेबसाइट कैसे बनाते हैं",
        steps: [
          { no: "01", title: "अपनी प्रॉपर्टी समझें", desc: "हम आपके होटल, टारगेट मेहमान, लोकेशन, कमरे, सुविधाएँ और बिज़नेस ज़रूरतों को समझते हैं।" },
          { no: "02", title: "अपनी वेबसाइट डिज़ाइन करें", desc: "एक आधुनिक वेबसाइट बनाएँ जो आपकी प्रॉपर्टी के ब्रांड को दर्शाए और मेहमानों को प्रीमियम ब्राउज़िंग अनुभव दे।" },
          { no: "03", title: "होटल जानकारी जोड़ें", desc: "रूम विवरण, फ़ोटो, सुविधाएँ, लोकेशन, नीतियाँ और अन्य ज़रूरी प्रॉपर्टी जानकारी जोड़ें।" },
          { no: "04", title: "डायरेक्ट बुकिंग इंटीग्रेट करें", desc: "डायरेक्ट बुकिंग अवसर सक्षम करने के लिए बुकिंग इंजन और ज़रूरी सिस्टम कनेक्ट करें।" },
          { no: "05", title: "लॉन्च और सपोर्ट", desc: "वेबसाइट लाइव करें और अपडेट व सुधार के लिए निरंतर सपोर्ट दें।" },
        ],
        whyHeading: "वेबसाइट विज़िटर को डायरेक्ट बुकिंग अवसरों में बदलें",
        whyText:
          "आपकी वेबसाइट को सिर्फ़ आपके होटल की जानकारी दिखाने से ज़्यादा करना चाहिए। Superhost Cloud ऐसी होटल वेबसाइट बनाता है जो आपकी प्रॉपर्टी को दिखाने, भरोसा बनाने और आपके मेहमानों के लिए बुकिंग यात्रा को सरल बनाने के लिए डिज़ाइन की गई हैं।",
        whyTagline: "आपका होटल। आपकी वेबसाइट। आपकी डायरेक्ट बुकिंग।",
        bulletsHeading: "होटल Superhost Cloud क्यों चुनते हैं",
        bullets: [
          "प्रोफ़ेशनल होटल वेबसाइट",
          "मोबाइल-फ्रेंडली डिज़ाइन",
          "डायरेक्ट बुकिंग इंजन",
          "कमीशन-फ्री डायरेक्ट बुकिंग अवसर",
          "होटल रूम और सुविधा प्रदर्शन",
          "SEO-फ्रेंडली स्ट्रक्चर",
          "आसान पूछताछ विकल्प",
          "निरंतर वेबसाइट सपोर्ट",
        ],
        closingHeading: "अपने होटल की वेबसाइट बनाने के लिए तैयार हैं?",
        closingText: "अपने होटल को एक प्रोफ़ेशनल ऑनलाइन उपस्थिति दें और मेहमानों के लिए सीधे बुकिंग करना आसान बनाएँ।",
      },
      "social-media": {
        subtitle: "अपने होटल के सोशल मीडिया को एक ग्रोथ चैनल में बदलें",
        body:
          "आपका होटल केवल एक सोशल मीडिया पेज से ज़्यादा का हक़दार है। Superhost Cloud होटलों को प्रोफ़ेशनल कंटेंट, आकर्षक कैंपेन और हॉस्पिटैलिटी इंडस्ट्री के लिए ख़ास डिज़ाइन की गई टारगेटेड डिजिटल मार्केटिंग के ज़रिए मज़बूत सोशल मीडिया उपस्थिति बनाने में मदद करता है।",
        heroButtons: [{ label: "शुरू करें", type: "primary", action: "contact" }],
        featuresHeading: "एक मज़बूत सोशल उपस्थिति बनाएँ",
        features: [
          { title: "प्रोफ़ेशनल कंटेंट", desc: "आकर्षक पोस्ट, रील और स्टोरी बनाएँ जो आपके कमरे, सुविधाएँ, अनुभव, ऑफ़र और प्रॉपर्टी दिखाएँ।" },
          { title: "टारगेटेड कैंपेन", desc: "आपके होटल और लोकेशन के लिए सही ऑडियंस तक पहुँचने के लिए डिज़ाइन किए गए सोशल मीडिया कैंपेन चलाएँ।" },
          { title: "रील और विज़ुअल कंटेंट", desc: "आकर्षक शॉर्ट-फ़ॉर्म कंटेंट बनाएँ जो आपकी प्रॉपर्टी को अलग दिखाए और ज़्यादा संभावित मेहमानों तक पहुँचाए।" },
          { title: "होटल प्रमोशन", desc: "अपने सोशल मीडिया चैनलों के ज़रिए सीज़नल ऑफ़र, पैकेज, इवेंट और स्पेशल डील प्रमोट करें।" },
          { title: "प्रदर्शन ट्रैकिंग", desc: "रीच, एंगेजमेंट और कैंपेन प्रदर्शन की निगरानी करें ताकि समझ सकें कि आपकी प्रॉपर्टी के लिए क्या काम कर रहा है।" },
          { title: "ऑडियंस एंगेजमेंट", desc: "लगातार सोशल मीडिया कम्युनिकेशन के ज़रिए संभावित और मौजूदा मेहमानों से मज़बूत जुड़ाव बनाएँ।" },
        ],
        stepsHeading: "हमारी सोशल मीडिया मार्केटिंग कैसे काम करती है",
        steps: [
          { no: "01", title: "अपना होटल समझें", desc: "हम आपकी प्रॉपर्टी, लोकेशन, टारगेट ऑडियंस, USP और बिज़नेस लक्ष्य समझते हैं।" },
          { no: "02", title: "अपनी कंटेंट रणनीति बनाएँ", desc: "हम आपके होटल के कमरे, सुविधाएँ, ऑफ़र, लोकेशन और गेस्ट अनुभव के आसपास कंटेंट प्लान करते हैं।" },
          { no: "03", title: "बनाएँ और पब्लिश करें", desc: "हमारी टीम आपके चुने हुए सोशल प्लेटफ़ॉर्म पर आकर्षक पोस्ट, रील और स्टोरी बनाती और पब्लिश करती है।" },
          { no: "04", title: "अपनी प्रॉपर्टी प्रमोट करें", desc: "हम आपके होटल की ऑनलाइन रीच बढ़ाने के लिए प्रासंगिक कैंपेन और प्रमोशन का उपयोग करते हैं।" },
          { no: "05", title: "ट्रैक और सुधार करें", desc: "हम प्रदर्शन की निगरानी करते हैं और कंटेंट व कैंपेन रणनीति में लगातार सुधार करते हैं।" },
        ],
        whyHeading: "अपने होटल को ऑनलाइन अलग दिखाएँ",
        whyText:
          "आपके मेहमान पहले से ही सोशल मीडिया पर समय बिता रहे हैं। लक्ष्य यह है कि जब वे अपनी अगली ठहर खोज रहे हों तो आपका होटल दिखे, आकर्षक लगे और याद रहे। Superhost Cloud आपकी सोशल मीडिया उपस्थिति को आपके होटल के लिए एक निरंतर मार्केटिंग चैनल में बदलने में मदद करता है।",
        whyTagline: "ज़्यादा विज़िबिलिटी। बेहतर एंगेजमेंट। मज़बूत होटल ब्रांड।",
        bulletsHeading: "होटल Superhost Cloud क्यों चुनते हैं",
        bullets: [
          "होटल-केंद्रित सोशल मीडिया रणनीति",
          "प्रोफ़ेशनल पोस्ट और रील",
          "सोशल मीडिया कैंपेन",
          "प्रॉपर्टी और ऑफ़र प्रमोशन",
          "ऑडियंस टारगेटिंग",
          "प्रदर्शन ट्रैकिंग",
          "निरंतर कंटेंट प्रबंधन",
        ],
        closingHeading: "अपने होटल को सोशल मीडिया पर बढ़ाने के लिए तैयार हैं?",
        closingText: "Superhost Cloud को अपनी मज़बूत डिजिटल उपस्थिति बनाने और ज़्यादा संभावित मेहमानों तक पहुँचने में मदद करने दें।",
      },
      "owner-support": {
        subtitle: "आपके होटल की ऑनलाइन बुकिंग के लिए भरोसेमंद सपोर्ट",
        body:
          "ऑनलाइन बुकिंग मैनेज करने में कई चैनल, बुकिंग सिस्टम, रेट, उपलब्धता और गेस्ट सवाल शामिल हो सकते हैं। Superhost Cloud होटलों को बुकिंग-संबंधी समस्याओं को सहजता से मैनेज और हल करने में मदद के लिए समर्पित सपोर्ट देता है।",
        heroButtons: [{ label: "शुरू करें", type: "primary", action: "contact" }],
        featuresHeading: "आपके ऑनलाइन बुकिंग ऑपरेशन के लिए सपोर्ट",
        features: [
          { title: "बुकिंग सहायता", desc: "बुकिंग-संबंधी सवालों, रिज़र्वेशन विवरण और बुकिंग समस्याओं में मदद पाएँ।" },
          { title: "OTA सपोर्ट", desc: "OTA लिस्टिंग, बुकिंग और चैनल-संबंधी सवालों में सहायता पाएँ।" },
          { title: "रेट और उपलब्धता सपोर्ट", desc: "रूम रेट, उपलब्धता और इन्वेंट्री सिंक्रोनाइज़ेशन से जुड़ी समस्याओं में मदद पाएँ।" },
          { title: "टेक्नोलॉजी सपोर्ट", desc: "Superhost Cloud की टेक्नोलॉजी, डैशबोर्ड और जुड़े हुए सिस्टम में सहायता पाएँ।" },
          { title: "गेस्ट बुकिंग सपोर्ट", desc: "बुकिंग-संबंधी उन समस्याओं को हल करें जो आपके गेस्ट अनुभव को प्रभावित कर सकती हैं।" },
          { title: "समर्पित सहायता", desc: "ऐसी सपोर्ट टीम से जुड़ें जो होटल ऑपरेशन और ऑनलाइन बुकिंग वर्कफ़्लो को समझती है।" },
        ],
        stepsHeading: "हमारा बुकिंग सपोर्ट कैसे काम करता है",
        steps: [
          { no: "01", title: "हमारी टीम से संपर्क करें", desc: "अपनी बुकिंग-संबंधी समस्या के साथ हमारी सपोर्ट टीम से संपर्क करें।" },
          { no: "02", title: "विवरण साझा करें", desc: "संबंधित बुकिंग, प्रॉपर्टी या सिस्टम जानकारी प्रदान करें।" },
          { no: "03", title: "विशेषज्ञ मार्गदर्शन पाएँ", desc: "हमारी टीम समस्या की समीक्षा करती है और आपको सही समाधान की ओर मार्गदर्शन देती है।" },
          { no: "04", title: "फिर से बिज़नेस पर लौटें", desc: "समस्या हल करें और अपने होटल ऑपरेशन को सहजता से मैनेज करना जारी रखें।" },
        ],
        whyHeading: "बुकिंग समस्याओं को अपनी रफ़्तार धीमी न करने दें",
        whyText:
          "ऑनलाइन बुकिंग समस्याएँ आपके होटल के ऑपरेशन और गेस्ट अनुभव को प्रभावित कर सकती हैं। Superhost Cloud के साथ, आपके पास एक समर्पित सपोर्ट टीम है जो आपको बुकिंग, OTA, टेक्नोलॉजी और प्लेटफ़ॉर्म-संबंधी सवालों में मदद करती है।",
        whyTagline: "आपका होटल। आपकी बुकिंग। हमारा सपोर्ट।",
        bulletsHeading: "होटल हमारा सपोर्ट क्यों चुनते हैं",
        bullets: [
          "होटल-केंद्रित सपोर्ट",
          "ऑनलाइन बुकिंग सहायता",
          "OTA और चैनल सपोर्ट",
          "रेट और इन्वेंट्री मार्गदर्शन",
          "टेक्नोलॉजी सहायता",
          "ज़रूरत पड़ने पर इंसानी सपोर्ट",
        ],
        closingHeading: "अपनी ऑनलाइन बुकिंग में मदद चाहिए?",
        closingText: "Superhost Cloud सपोर्ट टीम से जुड़ें और अपने होटल के ऑनलाइन बुकिंग ऑपरेशन में सहायता पाएँ।",
      },
    },
    serviceDetail: {
      "ota-management": {
        tagline: "जहाँ भी आपके मेहमान खोज रहे हैं, वहाँ नज़र आएँ।",
        intro:
          "Superhost Cloud आपके होटल की OTA लिस्टिंग को सेटअप, ऑप्टिमाइज़ और मैनेज करने में मदद करता है — जिसमें प्रॉपर्टी डिटेल, रूम जानकारी, फ़ोटो, विवरण, रेट, उपलब्धता और पॉलिसी को सही ढंग से मेंटेन किया जाता है।",
        benefits: [
          "OTA लिस्टिंग सेटअप – होटल को सही OTA प्लेटफ़ॉर्म पर लिस्ट करना",
          "प्रोफ़ाइल ऑप्टिमाइज़ेशन – होटल विवरण, सुविधाएँ, रूम डिटेल और फ़ोटो को प्रोफेशनली प्रस्तुत करना",
          "रेट और इन्वेंटरी मैनेजमेंट – रेट और रूम उपलब्धता को अपडेट रखना",
          "कंटेंट मैनेजमेंट – प्रॉपर्टी जानकारी और रूम डिटेल को सटीक रखना",
          "विज़िबिलिटी सुधार – बेहतर ऑनलाइन उपस्थिति के लिए लिस्टिंग ऑप्टिमाइज़ करना",
          "निरंतर मैनेजमेंट – OTA लिस्टिंग में ज़रूरी अपडेट और बदलाव संभालना",
        ],
        points: [
          { h: "ज़्यादा विज़िबिलिटी", p: "जहाँ 80% होटल सर्च होते हैं, उन प्लेटफ़ॉर्म पर ऊपर रैंक करें।" },
          { h: "ज़्यादा बुकिंग", p: "ऑप्टिमाइज़ लिस्टिंग देखने वालों को कन्फर्म बुकिंग में बदलती है।" },
          { h: "कोई अनुमान नहीं", p: "सेटअप, कंटेंट और फ़ोटो सब हमारी टीम शुरू से अंत तक संभालती है।" },
        ],
      },
      "channel-management": {
        tagline: "एक डैशबोर्ड। हर चैनल। हमेशा सिंक में।",
        intro:
          "दस अलग-अलग OTA पर हाथ से रेट और उपलब्धता संभालना ही ओवरबुकिंग और रेवेन्यू नुकसान की वजह बनता है। हमारा चैनल मैनेजर हर प्लेटफ़ॉर्म को एक डैशबोर्ड से जोड़ता है — रेट एक बार बदलें और वह सेकंडों में हर जगह अपडेट हो जाए।",
        benefits: [
          "हर जुड़े OTA पर रेट और इन्वेंटरी का रियल-टाइम सिंक",
          "ओवरबुकिंग और डबल बुकिंग को हमेशा के लिए ख़त्म करें",
          "प्राइस एक बार अपडेट करें — 10 सेकंड से कम में हर जगह लागू",
          "आपकी सभी बुकिंग का एक जगह केंद्रीकृत कैलेंडर व्यू",
          "पूरे भरोसे के साथ ज़्यादा इन्वेंटरी ऑनलाइन डालें",
        ],
        points: [
          { h: "कोई ओवरबुकिंग नहीं", p: "इन्वेंटरी हर चैनल पर तुरंत अपडेट होती है।" },
          { h: "रोज़ घंटों की बचत", p: "हर सुबह दस अलग एक्स्ट्रानेट में लॉगिन करना बंद करें।" },
          { h: "ज़्यादा कमरे बेचें", p: "पूरी इन्वेंटरी हर चैनल पर आत्मविश्वास से लिस्ट करें।" },
        ],
      },
      "whatsapp-automation": {
        tagline: "अपने मेहमानों से वहीं मिलें जहाँ वे पहले से हैं।",
        intro:
          "आपके मेहमान ईमेल नहीं देखते — वे व्हाट्सऐप देखते हैं। Superhost Cloud बुकिंग कन्फर्मेशन, पेमेंट रिमाइंडर, चेक-इन जानकारी और पूछताछ के तुरंत जवाब को ऑटोमेट करता है, ताकि कोई लीड ठंडी न पड़े और हर मेहमान को अच्छा महसूस हो।",
        benefits: [
          "ऑटोमेटिक बुकिंग कन्फर्मेशन और आगमन-पूर्व संदेश",
          "पूछताछ के तुरंत जवाब — फ्रंट डेस्क बंद होने के बाद भी",
          "पेमेंट लिंक और रिमाइंडर सीधे व्हाट्सऐप पर",
          "स्टे के बाद रिव्यू अनुरोध जो आपकी OTA रेटिंग बढ़ाएँ",
          "ज़्यादा कन्वर्ज़न — घंटों में नहीं, सेकंडों में जवाब दें",
        ],
        points: [
          { h: "कोई लीड न छूटे", p: "रात में भी पूछताछ का 24/7 ऑटो-रिप्लाई।" },
          { h: "तेज़ पेमेंट", p: "पेमेंट लिंक और रिमाइंडर सीधे चैट में भेजें।" },
          { h: "खुश मेहमान", p: "समय पर अपडेट जो मेहमान सच में पढ़ते हैं।" },
        ],
      },
    },
    about: {
      eyebrow: "Superhost Cloud के बारे में",
      title1: "भारत का पहला और सबसे तेज़ी से बढ़ता AI-नेटिव हॉस्पिटैलिटी टेक्नोलॉजी इंफ्रास्ट्रक्चर ब्रांड",
      title2: "— हर एकोमोडेशन का बुकिंग और रेवेन्यू ग्रोथ पार्टनर",
      paragraph:
        "Superhost Cloud एक हॉस्पिटैलिटी टेक्नोलॉजी और होटल मैनेजमेंट कंपनी है, जो उन भारतीय होटल मालिकों के लिए बनी है जो ख़राब लिस्टिंग, ओवरबुकिंग और न चलने वाली टेक्नोलॉजी की वजह से बुकिंग खोकर थक चुके हैं।",
      storyEyebrow: "हमारी कहानी",
      storyTitle: "उन लोगों ने बनाया जो होटल समझते हैं",
      storyParas: [
        "हमने Superhost Cloud तब शुरू किया जब हमने देखा कि शानदार, बढ़िया चलने वाले होटल ऑनलाइन संघर्ष कर रहे हैं — इसलिए नहीं कि उनके कमरे अच्छे नहीं थे, बल्कि इसलिए कि उनके पीछे की टेक्नोलॉजी और डिस्ट्रीब्यूशन बिखरा हुआ था।",
        "लिस्टिंग अधूरी थीं। रेट सिंक से बाहर थे। पूछताछ घंटों अनुत्तरित रहती थी। मालिक उन बुकिंग पर कमीशन दे रहे थे जो वे सीधे जीत सकते थे। हमें पता था कि इससे बेहतर तरीका है।",
        "आज हम पूरे भारत के होटल और रिज़ॉर्ट के लिए ऑनलाइन उपस्थिति, बुकिंग और टेक्नोलॉजी संभालते हैं — मालिकों को उनका समय, उनका मुनाफ़ा और उनकी शांति लौटाते हैं।",
      ],
      missionTitle: "हमारा मिशन",
      mission:
        "भारत के हर एकोमोडेशन मालिक को वह टेक्नोलॉजी, विज़िबिलिटी और सपोर्ट देना जो बड़ी चेन के लिए आम बात है — ताकि वे अपनी शर्तों पर मुक़ाबला कर सकें और जीत सकें।",
      visionTitle: "हमारा विज़न",
      vision:
        "एक ऐसा भविष्य जहाँ मुनाफ़े वाला, पूरी तरह बुक एकोमोडेशन चलाने के लिए टेक टीम की ज़रूरत न हो — बस एक भरोसेमंद पार्टनर जो सब संभाले।",
      trustTitle: "होटल मालिक हम पर क्यों भरोसा करते हैं",
      values: [
        { h: "मालिक-पहले", p: "हमारा हर फ़ैसला एक सवाल पर तौला जाता है: क्या इससे होटल मालिक की कमाई बढ़ती है?" },
        { h: "तेज़ और भरोसेमंद", p: "सेकंडों में रेट बदलाव, मिनटों में जवाब, और सपोर्ट जो ज़रूरत पर सच में मौजूद हो।" },
        { h: "असली लोग", p: "एक समर्पित टीम जो भारतीय हॉस्पिटैलिटी समझती है — कोई टिकट क़तार नहीं।" },
      ],
    },
    contact: {
      eyebrow: "संपर्क करें",
      title1: "बात करें",
      title2: "बुकिंग की",
      paragraph:
        "हमें अपनी प्रॉपर्टी के बारे में बताएँ और हम 24 घंटे के भीतर आपसे संपर्क करेंगे। तुरंत चाहिए? व्हाट्सऐप बटन दबाएँ।",
      whatsappBtn: "व्हाट्सऐप पर चैट करें",
      cards: {
        whatsapp: "व्हाट्सऐप / कॉल",
        email: "ईमेल",
        location: "स्थान",
        support: "सपोर्ट",
        supportValue: "सोम–शनि, सुबह 10 – शाम 6 (IST)",
      },
      formEyebrow: "लीड फ़ॉर्म",
      formTitle: "हमें अपनी जानकारी भेजें",
      formParagraph:
        "फ़ॉर्म भरें और हमारी टीम आपके होटल के लिए अनुकूलित प्लान के साथ संपर्क करेगी। सभी जानकारी सुरक्षित रूप से संग्रहित होती है।",
      whyTitle: "संपर्क क्यों करें?",
      whyText: "मुफ़्त लिस्टिंग ऑडिट, स्पष्ट ग्रोथ प्लान और ईमानदार सलाह — कोई दबाव नहीं, कोई जटिल भाषा नहीं।",
    },
    footer: {
      tagline:
        "भारतीय एकोमोडेशन मालिकों के लिए बनी हॉस्पिटैलिटी टेक्नोलॉजी — ज़्यादा बुकिंग, बेहतर विज़िबिलिटी, आसान प्रॉपर्टी मैनेजमेंट।",
      company: "कंपनी",
      popularServices: "लोकप्रिय सेवाएँ",
      getInTouch: "संपर्क में रहें",
      brand: "Superhostcloud",
      chatWhatsapp: "व्हाट्सऐप पर चैट करें",
      rights: "सर्वाधिकार सुरक्षित।",
      madeIn: "भारत में, भारतीय हॉस्पिटैलिटी के लिए बनाया गया।",
      privacy: "प्राइवेसी पॉलिसी",
      terms: "नियम और शर्तें",
    },
  },
};
